"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6413],{

/***/ 1795:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ ORDER_DETAIL_V2_COMPONENT_MAPPER)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Contact/index.ts + 4 modules
var OrderDetailV2Contact = __webpack_require__(11941);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ForInsurance/index.ts + 2 modules
var OrderDetailV2ForInsurance = __webpack_require__(32402);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Nominee/index.ts + 3 modules
var OrderDetailV2Nominee = __webpack_require__(81312);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2OrderData/OrderDetailV2OrderData.tsx



const OrderDetailV2OrderData = ({
  insPlanName,
  insuranceInfo,
  insuranceType,
  orderDetailIcon,
  orderDetails
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components.OrderDetailInsurance, {
    insPlanName: insPlanName,
    insuranceInfo: insuranceInfo,
    insuranceType: insuranceType,
    orderDetailIcon: orderDetailIcon,
    orderDetails: orderDetails,
    forInsuranceContainer: undefined,
    "data-test-id": "OrderDetailV2OrderData-OrderDetailInsurance"
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2OrderData/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PaymentInfo/index.ts + 1 modules
var OrderDetailV2PaymentInfo = __webpack_require__(10975);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PolicyDownload/index.ts + 1 modules
var OrderDetailV2PolicyDownload = __webpack_require__(58962);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PriceBreakup/index.ts + 2 modules
var OrderDetailV2PriceBreakup = __webpack_require__(54412);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Travellers/index.ts + 1 modules
var OrderDetailV2Travellers = __webpack_require__(39922);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/ComponentMapper.ts








const ORDER_DETAIL_V2_COMPONENT_MAPPER = {
  left: {
    COMPONENT_ORDER_DETAILS_PAGE_ORDER_DATA: OrderDetailV2OrderData,
    COMPONENT_ORDER_DETAILS_PAGE_ENTITY_DETAIL: OrderDetailV2Travellers/* OrderDetailV2Travellers */.m,
    COMPONENT_ORDER_DETAILS_PAGE_NOMINEE_DETAIL: OrderDetailV2Nominee/* OrderDetailV2Nominee */.m,
    COMPONENT_ORDER_DETAILS_PAGE_CONTACT_DETAIL: OrderDetailV2Contact/* OrderDetailV2Contact */.O
  },
  right: {
    COMPONENT_ORDER_DETAILS_PAGE_POLICY_DOWNLOAD: OrderDetailV2PolicyDownload/* OrderDetailV2PolicyDownload */.b,
    COMPONENT_ORDER_DETAILS_PAGE_ORDER_ACTIONS: OrderDetailV2ForInsurance/* OrderDetailV2ForInsurance */.o,
    COMPONENT_ORDER_DETAILS_PAGE_PRICE_BREAKUP: OrderDetailV2PriceBreakup/* OrderDetailV2PriceBreakup */.H,
    COMPONENT_ORDER_DETAILS_PAGE_PAYMENT_INFO: OrderDetailV2PaymentInfo/* OrderDetailV2PaymentInfo */.o
  }
};

/***/ }),

/***/ 72015:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ ComponentRenderer)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/ComponentMapper.ts + 2 modules
var ComponentMapper = __webpack_require__(1795);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/ComponentTransformer/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const safeText = (value, fallback = "") => value === undefined || value === null || value === "" ? fallback : String(value);
/**
 * Helper to handle boolean values that may be omitted from JSON (omitEmpty tag).
 * If the value is present (not undefined), use it. Otherwise, default to false.
 */


const getBooleanValue = value => {
  return value !== undefined ? value : false;
};
/**
 * Shared helper to extract and sanitise price breakup data.
 * Used by both PRICE_BREAKUP and PRICE_PAYMENT_INFO transformers.
 */


const extractPriceBreakup = priceBreakupData => {
  const rawBreakupList = Array.isArray(priceBreakupData?.breakupList) ? priceBreakupData.breakupList : [];
  const breakupList = rawBreakupList.filter(item => item && (item.label || item.value)).map(item => ({
    label: safeText(item?.label, ""),
    value: safeText(item?.value, ""),
    style: item?.style && typeof item.style === "object" ? item.style : {}
  }));
  const rawExtraCharges = Array.isArray(priceBreakupData?.extraCharges) ? priceBreakupData.extraCharges : [];
  const extraCharges = rawExtraCharges.filter(item => item && (item.label || item.value)).map(item => ({
    label: safeText(item?.label, ""),
    value: safeText(item?.value, ""),
    style: item?.style && typeof item.style === "object" ? item.style : {}
  }));
  let finalAmount;

  if (priceBreakupData?.finalAmount) {
    if (Array.isArray(priceBreakupData.finalAmount)) {
      const firstItem = priceBreakupData.finalAmount[0];

      if (firstItem && (firstItem.label || firstItem.value)) {
        finalAmount = {
          label: safeText(firstItem?.label, ""),
          value: safeText(firstItem?.value, ""),
          style: firstItem?.style && typeof firstItem.style === "object" ? firstItem.style : {}
        };
      }
    } else if (typeof priceBreakupData.finalAmount === "object") {
      const item = priceBreakupData.finalAmount;

      if (item && (item.label || item.value)) {
        finalAmount = {
          label: safeText(item?.label, ""),
          value: safeText(item?.value, ""),
          style: item?.style && typeof item.style === "object" ? item.style : {}
        };
      }
    }
  }

  return {
    breakupList,
    extraCharges,
    finalAmount
  };
};
/**
 * Safely extract the entities array from context.
 */


const getEntities = ctx => Array.isArray(ctx.pageData?.entities) ? ctx.pageData.entities : [];
/**
 * A transformer converts raw API component data into props for a React component.
 * Receives the component's raw `data` blob and the current context value.
 */


const COMPONENT_TRANSFORMER = {
  COMPONENT_ORDER_DETAILS_PAGE_ORDER_DATA: apiData => {
    const orderData = apiData || {};
    const header = orderData?.header || {};
    return {
      insPlanName: safeText(header?.title),
      insuranceInfo: header?.subTitle ? {
        text: {
          value: safeText(header.subTitle)
        }
      } : undefined,
      insuranceType: undefined,
      orderDetailIcon: safeText(header?.icon, constants/* ORDER_DETAIL_V2_ASSETS.TRIP_SECURED_ICON */.XK.TRIP_SECURED_ICON),
      orderDetails: Array.isArray(orderData?.orderDetailsList) ? orderData.orderDetailsList : []
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_BOOKING_INFO: apiData => {
    const bookingInfo = apiData || {};
    const header = bookingInfo?.header || {};
    const orderDetailsList = Array.isArray(bookingInfo?.orderDetailsList) ? bookingInfo.orderDetailsList : [];
    const actionsList = Array.isArray(bookingInfo?.actionsList) ? bookingInfo.actionsList : [];
    const orderDetails = orderDetailsList.map(item => ({
      label: safeText(item?.label),
      value: safeText(item?.value)
    }));
    const actionConfigs = bookingInfo?.actionsConfig || {};
    const items = actionsList.filter(a => getBooleanValue(a?.isVisible)).map(a => {
      const disabled = !getBooleanValue(a?.isEnabled);
      return {
        title: safeText(a?.label),
        icon: safeText(a?.icon),
        sectionType: safeText(a?.actionId) || safeText(a?.label),
        isDisabled: disabled
      };
    });
    return {
      orderDetails,
      title: safeText(header?.title),
      items,
      actionsConfig: actionConfigs
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_TOP_STATUS_CARD: apiData => {
    const orderData = apiData || {};
    const header = orderData?.header || {};
    const policyProcessing = orderData?.policyProcessing || {};
    const status = safeText(policyProcessing?.status, "");
    const display = policyProcessing?.displayData?.[status] || {};
    const showPolicyUpdateSection = Boolean(policyProcessing?.displayData?.[status]);
    const actionsList = Array.isArray(orderData?.actionsList) ? orderData.actionsList : [];
    const downloadAction = actionsList.find(a => getBooleanValue(a?.isVisible)) || actionsList[0];
    const title = safeText(display?.title);
    const subTitle = display?.subTitle !== undefined && display?.subTitle !== null ? safeText(display.subTitle) : undefined;
    const desc = display?.desc ? safeText(display.desc) : undefined;
    const titleColor = display?.titleColor ? safeText(display.titleColor) : undefined;
    const subTitleColor = display?.subTitleColor ? safeText(display.subTitleColor) : undefined;
    const descColor = display?.descColor ? safeText(display.descColor) : undefined;
    const statusUpper = status.toUpperCase();
    const showSpinner = statusUpper === "GENERATING_POLICY" || statusUpper === "UPDATING_POLICY";
    const statusIcon = display?.icon ? safeText(display.icon) : undefined;
    return {
      insPlanName: safeText(header?.title),
      insuranceType: undefined,
      orderDetailIcon: safeText(header?.icon, ""),
      policyStatus: {
        title,
        subTitle,
        desc,
        titleColor,
        subTitleColor,
        descColor,
        showSpinner,
        statusIcon
      },
      downloadAction: downloadAction ? {
        label: downloadAction?.label,
        actionId: downloadAction?.actionId,
        icon: downloadAction?.icon ? safeText(downloadAction.icon, "") : undefined,
        isEnabled: getBooleanValue(downloadAction?.isEnabled),
        isVisible: getBooleanValue(downloadAction?.isVisible)
      } : undefined,
      newPolicyUrl: safeText(orderData?.newPolicyUrl, ""),
      showPolicyUpdateSection
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_POLICY_DOWNLOAD: apiData => {
    const policy = apiData || {};
    const policyProcessing = policy?.policyProcessing || {};
    const status = safeText(policyProcessing?.status, "");
    const display = policyProcessing?.displayData?.[status] || {};
    const showPolicyUpdateSection = policyProcessing?.displayData?.[status] || false;
    const actionsList = Array.isArray(policy?.actionsList) ? policy.actionsList : [];
    const downloadAction = actionsList.find(a => getBooleanValue(a?.isVisible)) || actionsList[0];
    const title = safeText(display?.title, "");
    const subTitle = display?.subTitle !== undefined && display?.subTitle !== null ? safeText(display.subTitle, "") : undefined;
    const desc = display?.desc ? safeText(display.desc, "") : undefined;
    const titleColor = display?.titleColor ? safeText(display.titleColor, "") : undefined;
    const subTitleColor = display?.subTitleColor ? safeText(display.subTitleColor, "") : undefined;
    const descColor = display?.descColor ? safeText(display.descColor, "") : undefined;
    const statusUpper = status.toUpperCase();
    const showSpinner = statusUpper === "GENERATING_POLICY" || statusUpper === "UPDATING_POLICY";
    const statusIcon = display?.icon ? safeText(display.icon, "") : undefined;
    return {
      title,
      subTitle,
      desc,
      titleColor,
      subTitleColor,
      descColor,
      showSpinner,
      statusIcon,
      showPolicyUpdateSection,
      downloadAction: downloadAction ? {
        label: downloadAction?.label,
        actionId: downloadAction?.actionId,
        icon: downloadAction?.icon ? safeText(downloadAction.icon, "") : undefined,
        isEnabled: getBooleanValue(downloadAction?.isEnabled),
        isVisible: getBooleanValue(downloadAction?.isVisible)
      } : undefined,
      newPolicyUrl: safeText(policy?.newPolicyUrl, "")
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_PLAN_BENEFITS: apiData => {
    const plan = apiData || {};
    const planBenefits = plan?.planBenefits || {};
    const primaryBenefits = Array.isArray(planBenefits?.primaryBenefits) ? planBenefits.primaryBenefits : [];
    const moreBenefits = planBenefits?.moreBenefits;
    const moreBenefitsCount = moreBenefits && typeof moreBenefits === "object" ? Object.values(moreBenefits).reduce((acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0), 0) : 0;
    const totalBenefits = primaryBenefits.length + moreBenefitsCount;
    const remaining = Math.max(0, totalBenefits - Math.min(3, primaryBenefits.length));
    return {
      icon: constants/* ORDER_DETAIL_V2_ASSETS.PLAN_COVERAGE_ICON */.XK.PLAN_COVERAGE_ICON,
      title: safeText(plan?.header?.title),
      subTitle: safeText(planBenefits?.header?.title),
      benefits: primaryBenefits.slice(0, 3).map(b => ({
        title: safeText(b?.title),
        icon: b?.icon || undefined,
        priceNode: b?.subTitle ? {
          text: {
            value: safeText(b.subTitle)
          }
        } : undefined
      })),
      benefitsCTA: remaining ? `${remaining} More Benefits` : "",
      fallbackBenefitIcon: constants/* ORDER_DETAIL_V2_ASSETS.TRIP_SECURED_ICON */.XK.TRIP_SECURED_ICON,
      moreBenefits: moreBenefits || undefined,
      footer: planBenefits?.footer || undefined
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_ENTITY_DETAIL: (apiData, ctx) => {
    const entity = apiData || {};
    const header = entity?.header || {};
    const actions = Array.isArray(entity?.actionsList) ? entity.actionsList : [];
    const action = actions.find(a => getBooleanValue(a?.isVisible)) || actions[0] || {};
    const editFlow = entity?.editFlow || {};
    const form = entity?.form || {};
    const entities = getEntities(ctx);
    const disabled = !getBooleanValue(action?.isEnabled);
    const visible = getBooleanValue(action?.isVisible);
    const entityById = new Map(entities.map(e => [e?.id, e]));
    return {
      icon: safeText(header?.icon, constants/* ORDER_DETAIL_V2_ASSETS.PRIMARY_CONTACT_ICON */.XK.PRIMARY_CONTACT_ICON),
      title: safeText(header?.title),
      actionLabel: safeText(action?.text),
      isActionDisabled: disabled,
      isActionVisible: visible,
      actionDisabledReason: safeText(action?.disabledReason, ""),
      actionList: actions,
      persuasionText: getBooleanValue(entity?.persuasion?.isVisible) ? entity?.persuasion?.text : "",
      travellers: (Array.isArray(entity?.displayData) ? entity.displayData : []).map(t => {
        const matchedEntity = t?.entityId ? entityById.get(t.entityId) : undefined;
        const policyUrl = matchedEntity?.data?.["policyUrl"] ?? matchedEntity?.data?.["policyURL"];
        return _objectSpread({
          id: t?.entityId,
          title: safeText(t?.title),
          desc: t?.desc ? safeText(t.desc, "") : undefined,
          cta: t?.cta
        }, policyUrl ? {
          policyUrl: String(policyUrl)
        } : undefined);
      }),
      formConfig: form,
      modalConfig: editFlow?.modalConfig,
      entities: entities
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_NOMINEE_DETAIL: (apiData, ctx) => {
    const nominee = apiData || {};
    const header = nominee?.header || {};
    const actions = Array.isArray(nominee?.actionsList) ? nominee.actionsList : [];
    const action = actions.find(a => getBooleanValue(a?.isVisible)) || actions[0] || {};
    const displayData = Array.isArray(nominee?.displayData) ? nominee.displayData : [];
    const hasNominees = displayData.length > 0;
    const editFlow = nominee?.editFlow || {};
    const form = nominee?.form || {};
    const entities = getEntities(ctx); // Use commonActions.addNominee label if nominees exist, otherwise use action label

    const commonActions = nominee?.form?.commonActions || {};
    const actionLabel = hasNominees && commonActions?.addNominee?.label ? commonActions.addNominee.label : safeText(action?.label, "");
    const isActionVisible = getBooleanValue(action?.isVisible);
    const disabled = !getBooleanValue(action?.isEnabled);
    return {
      icon: safeText(header?.icon, constants/* ORDER_DETAIL_V2_ASSETS.PRIMARY_CONTACT_ICON */.XK.PRIMARY_CONTACT_ICON),
      title: safeText(header?.title),
      actionLabel,
      isActionDisabled: disabled,
      isActionVisible,
      actionDisabledReason: safeText(action?.disabledReason, ""),
      actionList: actions,
      persuasionText: nominee?.persuasion?.isVisible === true ? nominee?.persuasion?.text : undefined,
      nominees: displayData.map(n => ({
        entityId: n?.entityId,
        title: safeText(n?.title),
        subTitle: n?.subTitle ? safeText(n.subTitle) : undefined,
        desc: n?.desc ? safeText(n.desc) : undefined,
        icon: n?.icon || null
      })),
      formConfig: form,
      modalConfig: editFlow?.modalConfig,
      entities: entities
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_CONTACT_DETAIL: (apiData, ctx) => {
    const contact = apiData || {};
    const header = contact?.header || {};
    const displayData = contact?.displayData || {};
    const actions = Array.isArray(contact?.actionsList) ? contact.actionsList : [];
    const action = actions.find(a => getBooleanValue(a?.isVisible)) || actions[0] || {};
    const entities = getEntities(ctx);
    const primaryTraveller = entities.find(e => e?.data?.["isPrimary"]);
    const primaryData = primaryTraveller?.data || {};
    const hasAlternateContact = Boolean(primaryData?.["alternateContactNo"] || primaryData?.["alternateEmail"]);
    const primarySection = {
      title: displayData?.primarySection?.title || action?.label || undefined,
      icon: displayData?.primarySection?.icon || undefined,
      contact: {
        nameNode: {
          text: {
            value: safeText(primaryData?.["name"])
          }
        },
        emailNode: {
          text: {
            value: safeText(primaryData?.["primaryEmail"])
          }
        },
        contactNoNode: {
          text: {
            value: safeText(primaryData?.["primaryContactNo"])
          }
        }
      }
    };
    const alternateSection = {
      title: displayData?.alternateSection?.title || undefined,
      icon: displayData?.alternateSection?.icon || undefined,
      isVisible: getBooleanValue(displayData?.alternateSection?.isVisible),
      action: {
        label: action?.label || undefined,
        isEnabled: getBooleanValue(action?.isEnabled),
        isVisible: getBooleanValue(action?.isVisible)
      },
      contact: hasAlternateContact ? {
        nameNode: {
          text: {
            value: safeText(primaryData?.["name"])
          }
        },
        emailNode: {
          text: {
            value: safeText(primaryData?.["alternateEmail"])
          }
        },
        contactNoNode: {
          text: {
            value: safeText(primaryData?.["alternateContactNo"])
          }
        }
      } : undefined
    };
    return {
      sectionTitle: header?.title || undefined,
      sectionIcon: header?.icon || constants/* ORDER_DETAIL_V2_ASSETS.PRIMARY_CONTACT_ICON */.XK.PRIMARY_CONTACT_ICON,
      mailIcon: constants/* ORDER_DETAIL_V2_ASSETS.MAIL_ICON */.XK.MAIL_ICON,
      callIcon: constants/* ORDER_DETAIL_V2_ASSETS.CALL_ICON */.XK.CALL_ICON,
      primarySection,
      alternateSection,
      formConfig: contact?.form || null,
      modalConfig: contact?.editFlow?.modalConfig || null,
      primaryEntity: primaryTraveller || null
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_ORDER_ACTIONS: apiData => {
    const actionsData = apiData || {};
    const header = actionsData?.header || {};
    const actionConfigs = actionsData?.actionsConfig || {};
    const actionItemsRaw = Array.isArray(actionsData?.actionsList) ? actionsData.actionsList : [];
    const items = actionItemsRaw.filter(a => getBooleanValue(a?.isVisible)).map(a => {
      const disabled = !getBooleanValue(a?.isEnabled);
      return {
        title: safeText(a?.label),
        icon: safeText(a?.icon),
        sectionType: safeText(a?.actionId) || safeText(a?.label),
        isDisabled: disabled
      };
    });
    return {
      title: safeText(header?.title),
      items,
      actionsConfig: actionConfigs
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_PRICE_BREAKUP: apiData => {
    const price = apiData || {};
    const header = price?.header || {};
    const {
      breakupList,
      extraCharges,
      finalAmount
    } = extractPriceBreakup(price?.priceBreakup || {});
    return {
      title: safeText(header?.title),
      breakupList,
      extraCharges,
      finalAmount
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_PAYMENT_INFO: apiData => {
    const payment = apiData || {};
    const header = payment?.header || {};
    const paymentBreakup = Array.isArray(payment?.paymentBreakup) ? payment.paymentBreakup : [];
    const invoiceUrl = payment?.invoiceUrl;
    const actions = Array.isArray(payment?.actionsList) ? payment.actionsList : [];
    const invoiceAction = actions[0]; // DOWNLOAD INVOICE should not rely on policyProcessing status - only use isEnabled flag
    // Invoice availability is independent of policy generation/update status

    const disabled = !getBooleanValue(invoiceAction?.isEnabled);
    const actionText = safeText(invoiceAction?.label);
    return {
      title: safeText(header?.title),
      info: safeText(header?.subTitle),
      paymentBreakup,
      invoiceUrl,
      isActionDisabled: disabled,
      headerBackgroundColor: header?.style?.backgroundColor || Global/* theme.lightBlueBg */.rS.lightBlueBg,
      actionText
    };
  },
  COMPONENT_ORDER_DETAILS_PAGE_PRICE_PAYMENT_INFO: apiData => {
    const data = apiData || {};
    const header = data?.header || {};
    const priceInfo = data?.priceInfo || {};
    const paymentInfo = data?.paymentInfo || {};
    const {
      breakupList,
      extraCharges,
      finalAmount
    } = extractPriceBreakup(priceInfo?.priceBreakup || {}); // Extract payment breakup data

    const paymentBreakup = Array.isArray(paymentInfo?.paymentBreakup) ? paymentInfo.paymentBreakup.map(p => ({
      sourceText: safeText(p?.sourceText, ""),
      value: safeText(p?.value, "")
    })) : []; // Extract actions from root level

    const actions = Array.isArray(data?.actionsList) ? data.actionsList : [];
    const viewBreakupAction = actions.find(a => a?.actionId === "VIEW_PRICE_AND_PAYMENT_BREAKUP" || a?.actionId === "VIEW_PRICE_PAYMENT_BREAKUP" || a?.actionId === "VIEW_BREAKUP") || actions.find(a => getBooleanValue(a?.isVisible));
    const invoiceAction = actions.find(a => a?.actionId === "GET_GST_TAX_INVOICE" || a?.actionId === "DOWNLOAD_INVOICE" || a?.actionId === "GET_INVOICE");
    return {
      title: safeText(header?.title),
      breakupList,
      extraCharges,
      finalAmount,
      paymentBreakup,
      invoiceUrl: safeText(paymentInfo?.invoiceUrl, ""),
      isActionDisabled: !getBooleanValue(invoiceAction?.isEnabled),
      downloadInvoiceAction: safeText(invoiceAction?.label),
      headerBackgroundColor: paymentInfo?.header?.style?.backgroundColor || "#EAF5FF",
      viewBreakupAction: viewBreakupAction ? {
        label: safeText(viewBreakupAction?.label),
        isEnabled: getBooleanValue(viewBreakupAction?.isEnabled),
        isVisible: getBooleanValue(viewBreakupAction?.isVisible)
      } : undefined,
      invoiceAction: invoiceAction ? {
        label: safeText(invoiceAction?.label),
        isEnabled: getBooleanValue(invoiceAction?.isEnabled),
        isVisible: getBooleanValue(invoiceAction?.isVisible)
      } : undefined
    };
  }
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Context.tsx
var OrderDetailV2Context = __webpack_require__(23027);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/ComponentRenderer.tsx


function ComponentRenderer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ComponentRenderer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ComponentRenderer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ComponentRenderer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const ComponentRenderer = ({
  components,
  layout,
  mapper: customMapper
}) => {
  const ctx = (0,OrderDetailV2Context/* useOrderDetailV2 */.g)();
  const mapperToUse = customMapper || ComponentMapper/* ORDER_DETAIL_V2_COMPONENT_MAPPER */.i;
  const mapper = mapperToUse[layout] || {};

  if (!components) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: components.map((card, index) => {
      const CardComponent = mapper[card.id];
      const transformer = COMPONENT_TRANSFORMER[card.id];

      if (!CardComponent) {
        return null;
      }

      const key = card.id;
      const transformedData = transformer ? transformer(card.data, ctx) : card.data;

      if (transformedData && typeof transformedData === "object") {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, ComponentRenderer_objectSpread(ComponentRenderer_objectSpread({}, transformedData), {}, {
          "data-test-id": `ComponentRenderer-CardComponent-${key}`
        }), key);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, {
        data: transformedData,
        "data-test-id": `ComponentRenderer-CardComponent-${key}`
      }, key);
    })
  });
};
/* harmony default export */ const OrderDetailV2_ComponentRenderer = ((/* unused pure expression or super */ null && (ComponentRenderer)));

/***/ }),

/***/ 16186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": () => (/* binding */ Spinner),
/* harmony export */   "Ar": () => (/* binding */ BreadcrumbSep),
/* harmony export */   "Bs": () => (/* binding */ CardCtaDivider),
/* harmony export */   "Cv": () => (/* binding */ ContactBox),
/* harmony export */   "HE": () => (/* binding */ HeroTopSection),
/* harmony export */   "HN": () => (/* binding */ ContactGrid),
/* harmony export */   "IZ": () => (/* binding */ FormattedTextWrapper),
/* harmony export */   "Kq": () => (/* binding */ Stack),
/* harmony export */   "LR": () => (/* binding */ HeroTitle),
/* harmony export */   "Nt": () => (/* binding */ ContactMobileSectionHeader),
/* harmony export */   "Sg": () => (/* binding */ BreadcrumbBar),
/* harmony export */   "Su": () => (/* binding */ HeroImageWrapper),
/* harmony export */   "T3": () => (/* binding */ Page),
/* harmony export */   "Uo": () => (/* binding */ HeroTitleWrap),
/* harmony export */   "VM": () => (/* binding */ Hero),
/* harmony export */   "W2": () => (/* binding */ Container),
/* harmony export */   "W7": () => (/* binding */ ContactHeader),
/* harmony export */   "XE": () => (/* binding */ BackArrowButton),
/* harmony export */   "YW": () => (/* binding */ HeroContentPWA),
/* harmony export */   "Zb": () => (/* binding */ Card),
/* harmony export */   "bY": () => (/* binding */ BreadcrumbText),
/* harmony export */   "bu": () => (/* binding */ BookingInfoCtaList),
/* harmony export */   "ci": () => (/* binding */ CardCtaButtonList),
/* harmony export */   "d5": () => (/* binding */ ContactMobileTitle),
/* harmony export */   "fW": () => (/* binding */ CardPadding),
/* harmony export */   "gp": () => (/* binding */ InfoStrip),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "js": () => (/* binding */ PolicyStatusText),
/* harmony export */   "jw": () => (/* binding */ ContactMobileSection),
/* harmony export */   "kG": () => (/* binding */ PolicyStatusCard),
/* harmony export */   "l0": () => (/* binding */ HeroTitleSectionPWA),
/* harmony export */   "mo": () => (/* binding */ ContactLine),
/* harmony export */   "ri": () => (/* binding */ RowMeta),
/* harmony export */   "rj": () => (/* binding */ Grid),
/* harmony export */   "u5": () => (/* binding */ ContactBoxHeader),
/* harmony export */   "uT": () => (/* binding */ Body),
/* harmony export */   "vN": () => (/* binding */ SectionHeaderIcon),
/* harmony export */   "vx": () => (/* binding */ HeroHeader),
/* harmony export */   "wA": () => (/* binding */ ContactMobileContent),
/* harmony export */   "wb": () => (/* binding */ ListBox),
/* harmony export */   "wc": () => (/* binding */ ListRow),
/* harmony export */   "yA": () => (/* binding */ HeroTitlePWA)
/* harmony export */ });
/* unused harmony exports AccountPill, HeroShield, CardHeaderRow, CollapsedRow, ActionLink, SectionHeader, SectionHeaderLeft, PlanBox, BenefitGrid, BenefitCell, BenefitText, BenefitCta */
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84576);



const Page = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Page",
  componentId: "j6j2o-0"
})(["background:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite);
const Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Container",
  componentId: "j6j2o-1"
})(["width:1200px;margin:0 auto;padding:0 16px;@media ", "{width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const Hero = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Hero",
  componentId: "j6j2o-2"
})(["background:", ";position:relative;overflow:hidden;padding:18px 0 0;border-radius:0 0 16px 16px;@media ", "{padding:0;}"], props => props.bgColor || _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.neonGreen */ .rS.neonGreen, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const BreadcrumbBar = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__BreadcrumbBar",
  componentId: "j6j2o-3"
})(["display:flex;align-items:center;gap:10px;margin-bottom:14px;@media ", "{gap:8px;flex-wrap:wrap;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const AccountPill = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "OrderDetailV2style__AccountPill",
  componentId: "j6j2o-4"
})(["display:inline-flex;align-items:center;gap:8px;padding:8px 12px;border-radius:8px;border:1px solid ", ";background:transparent;cursor:pointer;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack);
const BreadcrumbText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "OrderDetailV2style__BreadcrumbText",
  componentId: "j6j2o-5"
})(["font-size:14px;line-height:18px;color:", ";font-weight:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, props => props.isBold ? 700 : 500);
const BreadcrumbSep = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "OrderDetailV2style__BreadcrumbSep",
  componentId: "j6j2o-6"
})(["font-size:14px;line-height:18px;color:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack);
const HeroShield = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroShield",
  componentId: "j6j2o-7"
})(["position:absolute;right:40px;top:-20px;pointer-events:none;opacity:0.8;@media ", "{right:-40px;top:-40px;opacity:0.35;transform:scale(0.7);transform-origin:top right;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const HeroHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroHeader",
  componentId: "j6j2o-8"
})(["display:flex;justify-content:space-between;align-items:flex-start;gap:24px;@media ", "{gap:16px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const HeroTitleWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroTitleWrap",
  componentId: "j6j2o-9"
})(["padding:8px 0 0;display:flex;flex-direction:column;gap:12px;flex:1;@media ", "{padding:4px 0 0;gap:8px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const HeroTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroTitle",
  componentId: "j6j2o-10"
})(["display:flex;flex-direction:column;gap:8px;@media ", "{gap:6px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const FormattedTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "OrderDetailV2style__FormattedTextWrapper",
  componentId: "j6j2o-11"
})(["b,strong{color:#000000;font-weight:400;}"]);
const HeroImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroImageWrapper",
  componentId: "j6j2o-12"
})(["flex-shrink:0;display:flex;align-items:flex-start;@media ", "{display:none;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const Body = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Body",
  componentId: "j6j2o-13"
})(["display:flex;flex-direction:column;padding:48px 0 40px;margin-top:-70px;@media ", "{padding:16px;margin-top:0;gap:16px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const Grid = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Grid",
  componentId: "j6j2o-14"
})(["display:grid;grid-template-columns:minmax(0,1fr) 360px;gap:16px;position:relative;z-index:2;@media ", "{grid-template-columns:1fr;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const HeroTopSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroTopSection",
  componentId: "j6j2o-15"
})(["padding:16px;display:flex;align-items:center;position:relative;"]);
const BackArrowButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "OrderDetailV2style__BackArrowButton",
  componentId: "j6j2o-16"
})(["background:transparent;border:none;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;width:24px;height:24px;&:focus{outline:none;}&:active{opacity:0.7;}"]);
const HeroTitleSectionPWA = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroTitleSectionPWA",
  componentId: "j6j2o-17"
})(["display:flex;justify-content:center;align-items:center;width:100%;padding:0 16px;"]);
const HeroTitlePWA = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroTitlePWA",
  componentId: "j6j2o-18"
})(["text-align:center;font-family:Lato;font-size:14px;font-style:normal;font-weight:700;line-height:normal;text-transform:capitalize;"]);
const HeroContentPWA = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__HeroContentPWA",
  componentId: "j6j2o-19"
})(["display:flex;flex-direction:column;gap:16px;padding:16px;"]);
const Stack = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Stack",
  componentId: "j6j2o-20"
})(["display:flex;flex-direction:column;gap:16px;"]);
const Card = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Card",
  componentId: "j6j2o-21"
})(["background:", ";border-radius:16px;overflow:hidden;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const CardCtaDivider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__CardCtaDivider",
  componentId: "j6j2o-22"
})(["position:relative;width:100%;height:1px;margin:0;padding-bottom:2px;overflow:visible;&::before{content:\"\";position:absolute;top:0;left:0;right:0;height:1px;background:", ";box-shadow:0 1px 2px rgba(74,74,74,0.2);z-index:1;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightSilver */ .rS.lightSilver);
const CardCtaButtonList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__CardCtaButtonList",
  componentId: "j6j2o-23"
})(["button:last-child{border-bottom-left-radius:16px;border-bottom-right-radius:16px;}"]);
const BookingInfoCtaList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__BookingInfoCtaList",
  componentId: "j6j2o-24"
})(["margin-top:-24px;"]);
const CardPadding = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__CardPadding",
  componentId: "j6j2o-25"
})(["padding:20px;@media ", "{padding:16px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const CardHeaderRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__CardHeaderRow",
  componentId: "j6j2o-26"
})(["display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:16px;"]);
const CollapsedRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__CollapsedRow",
  componentId: "j6j2o-27"
})(["background:", ";border-radius:16px;padding:18px 20px;display:flex;align-items:center;justify-content:space-between;box-shadow:0px 1px 8px rgba(0,0,0,0.08);@media ", "{padding:14px 16px;border-radius:0px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ContactGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactGrid",
  componentId: "j6j2o-28"
})(["display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin-top:12px;@media ", "{grid-template-columns:1fr;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ContactBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactBox",
  componentId: "j6j2o-29"
})(["border:1px solid ", ";border-radius:12px;padding:16px;display:flex;flex-direction:column;gap:8px;min-height:120px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro);
const ContactBoxHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactBoxHeader",
  componentId: "j6j2o-30"
})(["display:flex;align-items:center;justify-content:space-between;gap:10px;"]);
const ContactLine = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactLine",
  componentId: "j6j2o-31"
})(["display:flex;align-items:center;gap:8px;"]);
const ActionLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "OrderDetailV2style__ActionLink",
  componentId: "j6j2o-32"
})(["appearance:none;border:0;padding:0;background:transparent;color:", ";font-weight:700;font-size:14px;cursor:", ";opacity:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, props => props.disabled ? "not-allowed" : "pointer", props => props.disabled ? 0.45 : 1);
const ContactHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactHeader",
  componentId: "j6j2o-33"
})(["display:flex;align-items:center;gap:8px;margin-bottom:0;"]);
const ContactMobileSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactMobileSection",
  componentId: "j6j2o-34"
})(["background:", ";border-bottom:1px solid ", ";padding:16px;box-shadow:0px 0px 3px 0px rgba(0,0,0,0.2);position:relative;z-index:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, props => props.zIndex || 1);
const ContactMobileSectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactMobileSectionHeader",
  componentId: "j6j2o-35"
})(["margin-bottom:16px;"]);
const ContactMobileTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "OrderDetailV2style__ContactMobileTitle",
  componentId: "j6j2o-36"
})(["font-size:16px;font-weight:900;color:", ";font-family:\"Lato\",sans-serif;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText);
const ContactMobileContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ContactMobileContent",
  componentId: "j6j2o-37"
})(["display:flex;flex-direction:column;gap:4px;"]);
const PolicyStatusCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__PolicyStatusCard",
  componentId: "j6j2o-38"
})(["background:", ";border-radius:16px;padding:16px;display:flex;align-items:flex-start;justify-content:space-between;gap:12px;@media ", "{padding:0;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const PolicyStatusText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__PolicyStatusText",
  componentId: "j6j2o-39"
})(["display:flex;flex-direction:column;gap:6px;"]);
const spin = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Spinner",
  componentId: "j6j2o-40"
})(["width:18px;height:18px;border-radius:50%;border:2px solid ", ";border-top-color:", ";animation:", " 0.8s linear infinite;flex-shrink:0;margin-top:2px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, spin);
const InfoStrip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__InfoStrip",
  componentId: "j6j2o-41"
})(["background:", ";border-radius:8px;padding:10px 12px;margin-bottom:12px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlueBg */ .rS.lightBlueBg);
const ListBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ListBox",
  componentId: "j6j2o-42"
})(["border:1px solid ", ";border-radius:12px;overflow:hidden;@media ", "{border:0;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ListRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__ListRow",
  componentId: "j6j2o-43"
})(["padding:12px 16px;border-bottom:1px solid ", ";:last-child{border-bottom:none;}@media ", "{padding:8px 0;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const RowMeta = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__RowMeta",
  componentId: "j6j2o-44"
})(["display:flex;flex-wrap:wrap;gap:6px;align-items:center;"]);
const SectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__SectionHeader",
  componentId: "j6j2o-45"
})(["display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px;"]);
const SectionHeaderLeft = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__SectionHeaderLeft",
  componentId: "j6j2o-46"
})(["display:flex;align-items:center;gap:10px;"]);
const SectionHeaderIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__SectionHeaderIcon",
  componentId: "j6j2o-47"
})(["display:flex;align-items:center;flex-shrink:0;img{display:block;vertical-align:middle;}"]);
const PlanBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__PlanBox",
  componentId: "j6j2o-48"
})(["background:", ";border-radius:12px;padding:16px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText2 */ .rS.blueText2);
const BenefitGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__BenefitGrid",
  componentId: "j6j2o-49"
})(["margin-top:14px;background:", ";border-radius:10px;overflow:hidden;display:grid;grid-template-columns:2fr 2fr 2fr 0.9fr;@media ", "{grid-template-columns:1fr;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const BenefitCell = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__BenefitCell",
  componentId: "j6j2o-50"
})(["padding:12px 16px;border-right:1px solid ", ";display:flex;align-items:center;gap:10px;:last-child{border-right:none;}@media ", "{border-right:none;border-bottom:1px solid ", ";:last-child{border-bottom:none;}}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro);
const BenefitText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__BenefitText",
  componentId: "j6j2o-51"
})(["display:flex;flex-direction:column;gap:2px;min-width:0;"]);
const BenefitCta = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "OrderDetailV2style__BenefitCta",
  componentId: "j6j2o-52"
})(["width:100%;height:100%;border:0;background:transparent;color:", ";font-weight:700;font-size:12px;line-height:16px;cursor:pointer;padding:0;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText);
const Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailV2style__Divider",
  componentId: "j6j2o-53"
})(["width:100%;height:1px;background-color:", ";margin:8px 0;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro);

/***/ }),

/***/ 23027:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ OrderDetailV2Provider),
/* harmony export */   "g": () => (/* binding */ useOrderDetailV2)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);


const OrderDetailV2Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const OrderDetailV2Provider = ({
  value,
  children
}) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OrderDetailV2Context.Provider, {
  value: value,
  children: children
});
const useOrderDetailV2 = () => {
  const ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OrderDetailV2Context);

  if (!ctx) {
    throw new Error("useOrderDetailV2 must be used within OrderDetailV2Provider");
  }

  return ctx;
}; // Re-export types for backward compatibility

/***/ }),

/***/ 98888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OrderDetailV2_OrderDetailV2Wrapper)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/utils/mapHero.ts
var mapHero = __webpack_require__(59665);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/utils/normalize.ts
var normalize = __webpack_require__(18001);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ModalWrapper/ModalWrapper.tsx + 1 modules
var ModalWrapper = __webpack_require__(38949);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ActionModal/OrderDetailV2ActionModal.style.ts


const ActionModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2ActionModalstyle__ActionModalBody",
  componentId: "sc-1npmmu4-0"
})(["padding:32px 24px 32px;display:flex;flex-direction:column;align-items:center;text-align:center;"]);
const ActionModalTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2ActionModalstyle__ActionModalTitle",
  componentId: "sc-1npmmu4-1"
})(["font-weight:700;font-size:18px;line-height:1.4;color:", ";margin-bottom:8px;"], Global/* theme.blackText */.rS.blackText);
const ActionModalMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2ActionModalstyle__ActionModalMessage",
  componentId: "sc-1npmmu4-2"
})(["font-size:14px;line-height:1.5;color:", ";margin-bottom:24px;"], Global/* theme.greyText6 */.rS.greyText6);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ActionModal/OrderDetailV2ActionModal.tsx







const OrderDetailV2ActionModal = ({
  config,
  onClose
}) => {
  if (!config) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWrapper/* ModalWrapper */.A, {
    isOpen: Boolean(config),
    onClose: onClose,
    customWidth: "420px",
    "data-test-id": "OrderDetailV2ActionModal-ModalWrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ActionModalBody, {
      "data-test-id": "OrderDetailV2ActionModal-ActionModalBody",
      children: [config.iconType === "success" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: constants/* ORDER_DETAIL_V2_ASSETS.SUCCESS_ICON */.XK.SUCCESS_ICON,
        width: "56",
        height: "56",
        alt: "Success",
        margin: "0 auto 20px",
        "data-test-id": "OrderDetailV2ActionModal-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ActionModalTitle, {
        "data-test-id": "OrderDetailV2ActionModal-ActionModalTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: config.title,
          "data-test-id": "OrderDetailV2ActionModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ActionModalMessage, {
        "data-test-id": "OrderDetailV2ActionModal-ActionModalMessage",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: config.message,
          "data-test-id": "OrderDetailV2ActionModal-FormattedText"
        })
      }), config.primaryCta && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        customTitle: config.primaryCta.label,
        onClick: onClose,
        customWidth: "100%",
        "data-test-id": "OrderDetailV2ActionModal-LandingButton"
      })]
    })
  });
};
/* harmony default export */ const OrderDetailV2ActionModal_OrderDetailV2ActionModal = (OrderDetailV2ActionModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ActionModal/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/hooks/usePolicyPolling.ts
var usePolicyPolling = __webpack_require__(9629);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Context.tsx
var OrderDetailV2Context = __webpack_require__(23027);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Wrapper.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












// Lazy load device-specific components for code splitting
const OrderDetailV2Desktop = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7305), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3067), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726), __webpack_require__.e(8073), __webpack_require__.e(6206), __webpack_require__.e(8656), __webpack_require__.e(5063), __webpack_require__.e(6413), __webpack_require__.e(110), __webpack_require__.e(2789)]).then(__webpack_require__.bind(__webpack_require__, 12789)), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(12789)]
  }
});
const OrderDetailV2PWA = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7305), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3067), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726), __webpack_require__.e(8073), __webpack_require__.e(6206), __webpack_require__.e(8656), __webpack_require__.e(5063), __webpack_require__.e(6413), __webpack_require__.e(110), __webpack_require__.e(8211)]).then(__webpack_require__.bind(__webpack_require__, 48211)), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48211)]
  }
});

function OrderDetailV2Wrapper({
  data,
  showNav,
  orderActionHandlers
}) {
  const router = (0,next_router.useRouter)(); // ── Polling & order data ───────────────────────────────────────────────

  const {
    orderData,
    refreshOrderDetails
  } = (0,usePolicyPolling/* usePolicyPolling */.A)({
    data,
    routerQuery: router.query
  }); // ── Action modal state ─────────────────────────────────────────────────

  const {
    0: actionModal,
    1: setActionModal
  } = (0,react.useState)(null);
  const showActionModal = (0,react.useCallback)(config => {
    setActionModal(config);
  }, []);
  const openUrl = (0,react.useCallback)((url, openInNewTab) => {
    window.open(url, openInNewTab ? "_blank" : "_self");
  }, []); // ── Normalized data (memoized to avoid new object refs on every render) ─

  const currentNormalized = (0,react.useMemo)(() => (0,normalize/* normalizeOrderDetailsV2 */.M)(orderData), [orderData]);
  const ctxValue = (0,react.useMemo)(() => {
    return _objectSpread(_objectSpread({}, currentNormalized), {}, {
      refreshOrderDetails,
      orderActionHandlers,
      showActionModal,
      showNav,
      openUrl
    });
  }, [currentNormalized, refreshOrderDetails, orderActionHandlers, showActionModal, showNav, openUrl]);
  const heroData = (0,react.useMemo)(() => (0,mapHero/* mapHero */.G)(currentNormalized), [currentNormalized]);
  const device = (0,src/* useBreakpointV2 */.bU)(); // ── Render ─────────────────────────────────────────────────────────────

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2Context/* OrderDetailV2Provider */.S, {
    value: ctxValue,
    "data-test-id": "OrderDetailV2Provider",
    children: [device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2Desktop, {
      normalizedData: currentNormalized,
      heroData: heroData,
      "data-test-id": "OrderDetailV2Desktop"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2PWA, {
      normalizedData: currentNormalized,
      heroData: heroData,
      "data-test-id": "OrderDetailV2PWA"
    }), actionModal && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2ActionModal_OrderDetailV2ActionModal, {
      config: actionModal,
      onClose: () => setActionModal(null),
      "data-test-id": "OrderDetailV2ActionModal"
    })]
  });
}

/* harmony default export */ const OrderDetailV2_OrderDetailV2Wrapper = (OrderDetailV2Wrapper);

/***/ }),

/***/ 96542:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FF": () => (/* binding */ SheetFooter),
/* harmony export */   "HS": () => (/* binding */ AddButton),
/* harmony export */   "SA": () => (/* binding */ SubmitModalWrapper),
/* harmony export */   "Xd": () => (/* binding */ TravellerFormSection),
/* harmony export */   "i9": () => (/* binding */ EditTravellersSheetStyle),
/* harmony export */   "k$": () => (/* binding */ SaveButton),
/* harmony export */   "m5": () => (/* binding */ StickyErrorText),
/* harmony export */   "mz": () => (/* binding */ ModalFooter),
/* harmony export */   "sD": () => (/* binding */ StickyErrorBanner),
/* harmony export */   "ue": () => (/* binding */ SheetContent),
/* harmony export */   "vD": () => (/* binding */ ModalFooterActions),
/* harmony export */   "wL": () => (/* binding */ StickyErrorIcon)
/* harmony export */ });
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84576);


 // ── Modal-level layout ──────────────────────────────────────────────────

const TravellerFormSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__TravellerFormSection",
  componentId: "sc-1rbl7re-0"
})(["display:flex;flex-direction:column;gap:20px;padding-bottom:24px;max-height:calc(100vh - 200px);overflow-y:auto;overflow-x:hidden;@media ", "{padding:0;max-height:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__ModalFooter",
  componentId: "sc-1rbl7re-1"
})(["position:sticky;bottom:0;background:", ";padding:8px 30px 0;margin:auto -30px 0 -30px;border-top:1px solid ", ";display:flex;flex-direction:column;z-index:10;@media ", "{position:fixed;left:0;right:0;padding:0;margin:0;border-top:none;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightSilver */ .rS.lightSilver, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ModalFooterActions = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__ModalFooterActions",
  componentId: "sc-1rbl7re-2"
})(["display:flex;justify-content:flex-end;align-items:center;@media ", "{padding:16px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const SaveButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "EditTravellersModalstyle__SaveButton",
  componentId: "sc-1rbl7re-3"
})(["padding:12px 32px;background:", ";color:", ";border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:", ";transition:all 0.2s;min-width:140px;text-transform:uppercase;letter-spacing:0.5px;display:flex;align-items:center;justify-content:center;gap:8px;&:hover{background:", ";}&:active{transform:", ";}&:disabled{background:", ";cursor:not-allowed;transform:none;}@media ", "{width:100%;padding:14px 32px;}"], props => {
  if (props.isLoading) return _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText;
  if (props.hasChanges) return _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText;
  return _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText2 */ .rS.greyText2;
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, props => props.hasChanges && !props.isLoading ? "pointer" : "not-allowed", props => {
  if (props.isLoading || !props.hasChanges) return props.hasChanges ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText2 */ .rS.greyText2;
  return _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.prussianBlue */ .rS.prussianBlue;
}, props => props.hasChanges && !props.isLoading ? "scale(0.98)" : "none", _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText2 */ .rS.greyText2, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const AddButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "EditTravellersModalstyle__AddButton",
  componentId: "sc-1rbl7re-4"
})(["padding:8px 20px;background:transparent;border:2px solid ", ";border-radius:8px;color:", ";font-size:14px;font-weight:700;cursor:pointer;transition:all 0.2s ease-in-out;white-space:nowrap;text-transform:uppercase;min-width:fit-content;&:hover{background-color:", ";color:", ";}&:active{transform:scale(0.98);}&:focus{outline:none;box-shadow:0 0 0 2px rgba(0,140,255,0.3);}&:disabled{opacity:0.45;cursor:not-allowed;pointer-events:none;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const EditTravellersSheetStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__EditTravellersSheetStyle",
  componentId: "sc-1rbl7re-5"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:", ";overflow-y:scroll;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.disabledGrey2 */ .rS.disabledGrey2);
const SheetContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__SheetContent",
  componentId: "sc-1rbl7re-6"
})(["padding:16px;padding-bottom:100px;"]);
const SheetFooter = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__SheetFooter",
  componentId: "sc-1rbl7re-7"
})(["background:", ";padding:16px;position:fixed;bottom:0;left:0;right:0;z-index:10;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const SubmitModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__SubmitModalWrapper",
  componentId: "sc-1rbl7re-8"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;min-height:200px;"]);
const StickyErrorBanner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__StickyErrorBanner",
  componentId: "sc-1rbl7re-9"
})(["background:#fcdadb;border:1px solid #fcdadb;border-radius:0;padding:8px 32px;display:flex;align-items:center;gap:12px;margin:0 -30px;box-sizing:border-box;@media ", "{padding:8px 16px;margin:0 -16px;position:fixed;bottom:80px;left:0;right:0;z-index:15;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const StickyErrorIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellersModalstyle__StickyErrorIcon",
  componentId: "sc-1rbl7re-10"
})(["flex-shrink:0;display:flex;align-items:center;justify-content:center;width:24px;height:24px;"]);
const StickyErrorText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "EditTravellersModalstyle__StickyErrorText",
  componentId: "sc-1rbl7re-11"
})(["flex:1;font-family:\"Lato\",sans-serif;font-size:12px;font-weight:400;line-height:1;color:#4a4a4a;margin:0;white-space:pre-wrap;"]);

/***/ }),

/***/ 40648:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HS": () => (/* reexport */ EditTravellersModal_style/* AddButton */.HS),
  "rj": () => (/* reexport */ EditTravellersModal),
  "i9": () => (/* reexport */ EditTravellersModal_style/* EditTravellersSheetStyle */.i9),
  "mz": () => (/* reexport */ EditTravellersModal_style/* ModalFooter */.mz),
  "vD": () => (/* reexport */ EditTravellersModal_style/* ModalFooterActions */.vD),
  "l_": () => (/* reexport */ FormRenderer_style/* ModalRadioButtonStyle */.l_),
  "k$": () => (/* reexport */ EditTravellersModal_style/* SaveButton */.k$),
  "ue": () => (/* reexport */ EditTravellersModal_style/* SheetContent */.ue),
  "FF": () => (/* reexport */ EditTravellersModal_style/* SheetFooter */.FF),
  "sD": () => (/* reexport */ EditTravellersModal_style/* StickyErrorBanner */.sD),
  "wL": () => (/* reexport */ EditTravellersModal_style/* StickyErrorIcon */.wL),
  "m5": () => (/* reexport */ EditTravellersModal_style/* StickyErrorText */.m5),
  "SA": () => (/* reexport */ EditTravellersModal_style/* SubmitModalWrapper */.SA),
  "Xd": () => (/* reexport */ EditTravellersModal_style/* TravellerFormSection */.Xd)
});

// UNUSED EXPORTS: AddressFieldWrapper, DateFieldWrapper, DynamicFieldTrigger, ErrorBanner, ErrorIcon, FieldItem, FieldsFooter, FieldsGrid, FieldsRow, FormCard, GenderRow, GenderSection, GenderTypeItem, RadioFieldWrapper, TravellerFormFields

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/FormRenderer.style.ts
var FormRenderer_style = __webpack_require__(47560);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/index.ts + 10 modules
var FormRenderer = __webpack_require__(42105);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/InfoModalContent/index.ts + 1 modules
var InfoModalContent = __webpack_require__(7125);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/EditTravellersModal.style.ts
var EditTravellersModal_style = __webpack_require__(96542);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/EditTravellersModal.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










 // ── Entity data extractor for traveller form ────────────────────────────





const extractTravellerData = entity => entity.data; // ── Component ───────────────────────────────────────────────────────────


const EditTravellersModal = ({
  isOpen,
  onClose,
  formConfig: rawFormConfig,
  entities,
  bookingId,
  onSave,
  onEndorsementSuccess,
  modalTitle = "Edit Travellers",
  saveButtonLabel = "SAVE DETAILS"
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)(); // Normalize fields that may arrive as either arrays or maps from the API

  const formConfig = (0,react.useMemo)(() => (0,FormRenderer/* normalizeFormConfig */.A$)(rawFormConfig), [rawFormConfig]); // ── Shared form state ─────────────────────────────────────────────────

  const {
    formData,
    errors,
    initialDataRef,
    getFieldRef,
    handleMaskedFocus,
    handleMaskedBlur,
    handleFieldChange,
    handleDynamicFieldChange,
    toggleDynamicField,
    validateAllFields,
    hasFormDataChanged,
    setErrors
  } = (0,FormRenderer/* useFormRenderer */.OS)({
    isOpen,
    formConfig,
    entities,
    extractEntityData: extractTravellerData
  }); // ── Endorsement state (modal-specific) ────────────────────────────────

  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: endorsementView,
    1: setEndorsementView
  } = (0,react.useState)("form");
  const {
    0: endorsementData,
    1: setEndorsementData
  } = (0,react.useState)(null);
  const {
    0: apiErrorMessage,
    1: setApiErrorMessage
  } = (0,react.useState)(null);
  const pendingRefreshRef = (0,react.useRef)(false); // Reset endorsement state when modal opens

  const prevIsOpenRef = (0,react.useRef)(false);
  react.useEffect(() => {
    if (isOpen && !prevIsOpenRef.current) {
      setEndorsementView("form");
      setEndorsementData(null);
      setApiErrorMessage(null);
      setIsLoading(false);
    }

    prevIsOpenRef.current = isOpen;
  }, [isOpen]); // Clear API error when user edits a field

  const wrappedHandleFieldChange = (entityIndex, fieldKey, value) => {
    if (apiErrorMessage) setApiErrorMessage(null);
    handleFieldChange(entityIndex, fieldKey, value);
  };

  const wrappedHandleDynamicFieldChange = (entityIndex, triggerId, fieldKey, value) => {
    if (apiErrorMessage) setApiErrorMessage(null);
    handleDynamicFieldChange(entityIndex, triggerId, fieldKey, value);
  }; // ── Save / Close ──────────────────────────────────────────────────────


  const handleSave = async () => {
    if (!validateAllFields()) return;
    setIsLoading(true);

    try {
      const updatedEntities = entities.map((entity, index) => {
        const entityData = formData[index];

        const updatedData = _objectSpread({}, entity.data);

        formConfig.fields.forEach(field => {
          const fieldKey = field.name;
          let value = String(entityData[fieldKey] || "");

          if (field.type === "DATE" && value) {
            value = (0,FormRenderer/* convertYYYYMMDDToDDMMYYYY */.ej)(value);
          }

          updatedData[fieldKey] = value;
        });
        formConfig.dynamicFields?.forEach(df => {
          const dynamicData = entityData.dynamicFields?.[df.triggerId];

          if (dynamicData?.visible) {
            df.fields.forEach(field => {
              updatedData[field.name] = dynamicData[field.name] || "";
            });
          }
        });
        return _objectSpread(_objectSpread({}, entity), {}, {
          data: updatedData
        });
      });
      const payload = updatedEntities.map(e => _objectSpread({
        entityId: e.id
      }, e.data));
      const res = await (0,api/* submitEndorsement */.Yh)({
        bookingId,
        payload
      });
      setEndorsementData(res);
      const status = (res?.status ?? "").toUpperCase();

      if (status === "SUCCESS") {
        setEndorsementView("success");
        setApiErrorMessage(null);
        initialDataRef.current = JSON.parse(JSON.stringify(formData));
        await Promise.resolve(onSave(updatedEntities));
        pendingRefreshRef.current = true;
      } else if (status === "ERROR" || status === "VALIDATION_ERROR") {
        setApiErrorMessage(res?.desc || res?.subtitle || res?.title || "An error occurred. Please try again.");
        setEndorsementView("form");
      } else {
        setEndorsementView("generating");
      }
    } catch {
      setApiErrorMessage("An error occurred. Please try again.");
      setEndorsementView("form");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (pendingRefreshRef.current) {
      pendingRefreshRef.current = false;
      onEndorsementSuccess?.();
    }

    onClose();
  }; // ── Render ────────────────────────────────────────────────────────────


  if (!isOpen) return null;
  const isResultView = endorsementView === "success" || endorsementView === "generating";
  const formChanged = hasFormDataChanged();

  const renderFormContent = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* TravellerFormSection */.Xd, {
      "data-test-id": "EditTravellersModal-renderFormContent-TravellerFormSection",
      children: formData.map((entityData, entityIndex) => /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer/* FormCard */.Ec, {
        "data-test-id": `EditTravellersModal-renderFormContent-FormCard-${entityIndex}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer/* FormRendererFields */.vo, {
          entityIndex: entityIndex,
          entityData: entityData,
          entityErrors: errors[entityIndex] || {},
          formConfig: formConfig,
          getFieldRef: getFieldRef,
          handleFieldChange: wrappedHandleFieldChange,
          handleMaskedFocus: handleMaskedFocus,
          handleMaskedBlur: handleMaskedBlur,
          handleDynamicFieldChange: wrappedHandleDynamicFieldChange,
          toggleDynamicField: toggleDynamicField,
          setErrors: setErrors,
          "data-test-id": "EditTravellersModal-renderFormContent-FormRendererFields"
        })
      }, entityIndex))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* ModalFooter */.mz, {
      "data-test-id": "EditTravellersModal-renderFormContent-ModalFooter",
      children: [apiErrorMessage && /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* StickyErrorBanner */.sD, {
        "data-test-id": "EditTravellersModal-renderFormContent-StickyErrorBanner",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorIcon */.wL, {
          "data-test-id": "EditTravellersModal-renderFormContent-StickyErrorIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: constants/* ORDER_DETAIL_V2_ASSETS.VALIDATION_ERROR_ICON */.XK.VALIDATION_ERROR_ICON,
            width: "24",
            height: "24",
            alt: "Error",
            "data-test-id": "EditTravellersModal-renderFormContent-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorText */.m5, {
          "data-test-id": "EditTravellersModal-renderFormContent-StickyErrorText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              html: apiErrorMessage
            },
            "data-test-id": "EditTravellersModal-renderFormContent-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* ModalFooterActions */.vD, {
        "data-test-id": "EditTravellersModal-renderFormContent-ModalFooterActions",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SaveButton */.k$, {
          onClick: handleSave,
          hasChanges: formChanged,
          isLoading: isLoading,
          disabled: !formChanged || isLoading,
          "data-test-id": "EditTravellersModal-renderFormContent-SaveButton",
          children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.Spinner, {
              spinnerWidth: 16,
              spinnerColor: Global/* theme.whiteText */.rS.whiteText,
              thickness: 2,
              "data-test-id": "EditTravellersModal-renderFormContent-Spinner"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: saveButtonLabel,
              "data-test-id": "EditTravellersModal-renderFormContent-FormattedText"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: saveButtonLabel,
            "data-test-id": "EditTravellersModal-renderFormContent-FormattedText"
          })
        })
      })]
    })]
  });

  const renderResultView = () => /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SubmitModalWrapper */.SA, {
    "data-test-id": "EditTravellersModal-renderResultView-SubmitModalWrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoModalContent/* InfoModalContent */.T, {
      viewType: endorsementView,
      data: endorsementData,
      renderAction: data => {
        if (endorsementView === "success" && data.cta?.isEnabled !== false && data.cta?.label && data.newPolicyUrl) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SaveButton */.k$, {
            as: "a",
            href: data.newPolicyUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            hasChanges: true,
            isLoading: false,
            style: {
              marginTop: "16px",
              textDecoration: "none"
            },
            "data-test-id": "EditTravellersModal-renderResultView-SaveButton",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: data.cta.label,
              "data-test-id": "EditTravellersModal-renderResultView-FormattedText"
            })
          });
        }

        return null;
      },
      "data-test-id": "EditTravellersModal-renderResultView-InfoModalContent"
    })
  }); // Mobile: full-page sheet


  if (device === "sm") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components.ReactPortalComp, {
      "data-test-id": "EditTravellersModal-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* EditTravellersSheetStyle */.i9, {
        "data-test-id": "EditTravellersModal-EditTravellersSheetStyle",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingHeaderMobile, {
          displayWhiteHeader: true,
          headerTitle: isResultView ? "" : modalTitle,
          handleBackBtn: handleClose,
          "data-test-id": "EditTravellersModal-LandingHeaderMobile"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SheetContent */.ue, {
          "data-test-id": "EditTravellersModal-SheetContent",
          children: isResultView ? renderResultView() : renderFormContent()
        })]
      })
    });
  } // Desktop: modal


  return /*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalDweb/* default */.Z, {
    customTitle: isResultView ? "" : modalTitle,
    handleClick: handleClose,
    customWidth: isResultView ? "420px" : "80%",
    customHeight: isResultView ? "auto" : "640px",
    "data-test-id": "EditTravellersModal-CommonModalDweb",
    children: isResultView ? renderResultView() : renderFormContent()
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/index.ts
// Re-export form field styles from FormRenderer for backward compatibility.
// External consumers (e.g. ModalRadioButton, AddNomineeModal) may still
// import these from "../EditTravellersModal".





/***/ }),

/***/ 40050:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ FormInput_FormInput)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormInput/FormInput.style.ts



const FormInputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FormInputstyle__FormInputWrap",
  componentId: "sc-88o39f-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";flex:", ";flex-shrink:0;width:100%;"], props => props.margin || "0", p => p.flex ? p.flex : "");
const FormInputLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "FormInputstyle__FormInputLabel",
  componentId: "sc-88o39f-1"
})(["font-weight:700;font-size:14px;line-height:16px;color:", ";display:block;margin-bottom:8px;transition:all 0.3s ease;"], Global/* theme.greyText */.rS.greyText);
const FormInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "FormInputstyle__FormInputStyle",
  componentId: "sc-88o39f-2"
})(["background:", ";border:1px solid ", ";border-radius:8px;padding:10px 12px;font-weight:400;font-size:16px;line-height:19px;width:100%;height:44px;color:", ";transition:all 0.2s ease;&::placeholder{font-weight:400;color:", ";}&:focus{outline:none;border:1px solid ", ";background:", ";}&:disabled{opacity:0.6;cursor:not-allowed;background:", ";border-color:", ";}@media ", "{width:100%;}"], props => props.disabled ? Global/* theme.smokeWhite */.rS.smokeWhite : props.backgroundColor || Global/* theme.whiteText */.rS.whiteText, props => {
  if (props.hasError) return Global/* theme.redText2 */.rS.redText2;
  return Global/* theme.lightGreyText */.rS.lightGreyText;
}, Global/* theme.blackText */.rS.blackText, Global/* theme.lightBlack */.rS.lightBlack, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.smokeWhite */.rS.smokeWhite, Global/* theme.lightGreyText */.rS.lightGreyText, utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormInput/FormInput.tsx






const FormInput = /*#__PURE__*/react.forwardRef(({
  placeholderTxt,
  labelTxt,
  margin,
  errorState,
  inputValue,
  handleChange,
  flex,
  requiredField,
  handleKeyDown,
  maxInputLength,
  inputType,
  handleFocus,
  handleBlur,
  maxValue,
  minValue,
  autoComplete = "on",
  isDisabled,
  backgroundColor,
  hasError = false,
  showError = false
}, ref) => {
  const handleMouseWheel = event => {
    // Blur the input to prevent scroll from changing number/date values.
    // Note: calling preventDefault() is not allowed inside passive wheel listeners.
    event.target.blur();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInputWrap, {
    margin: margin,
    flex: flex,
    "data-test-id": "FormInput-FormInputWrap",
    children: [labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInputLabel, {
      "data-test-id": "FormInput-FormInputLabel",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "FormInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInputStyle, {
      ref: ref,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      hasError: hasError,
      id: labelTxt,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      min: minValue,
      max: maxValue,
      onWheel: handleMouseWheel,
      autoComplete: autoComplete,
      inputWidth: "100%",
      disabled: isDisabled,
      backgroundColor: backgroundColor,
      "data-test-id": "FormInput-FormInputStyle"
    }), showError && errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "xs",
      margin: "4px 0 0",
      color: Global/* theme.redText */.rS.redText,
      fontWeight: "bold",
      "data-test-id": "FormInput-SpanTag",
      children: errorState
    })]
  });
});
FormInput.displayName = "FormInput";
/* harmony default export */ const FormInput_FormInput = (FormInput);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormInput/index.ts


/***/ }),

/***/ 47560:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": () => (/* binding */ FormCard),
/* harmony export */   "H4": () => (/* binding */ ErrorBanner),
/* harmony export */   "Hi": () => (/* binding */ AddressFieldWrapper),
/* harmony export */   "OX": () => (/* binding */ GenderTypeItem),
/* harmony export */   "Pz": () => (/* binding */ ErrorIcon),
/* harmony export */   "Wt": () => (/* binding */ FieldsFooter),
/* harmony export */   "bC": () => (/* binding */ GenderSection),
/* harmony export */   "bW": () => (/* binding */ DateFieldWrapper),
/* harmony export */   "cB": () => (/* binding */ FieldsRow),
/* harmony export */   "l_": () => (/* binding */ ModalRadioButtonStyle),
/* harmony export */   "mJ": () => (/* binding */ RadioFieldWrapper),
/* harmony export */   "mZ": () => (/* binding */ FieldItem),
/* harmony export */   "mf": () => (/* binding */ DynamicFieldTrigger)
/* harmony export */ });
/* unused harmony exports FieldsGrid, GenderRow */
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84576);


 // ── Card wrapper for a single entity's form ─────────────────────────────

const FormCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__FormCard",
  componentId: "sc-1plgblb-0"
})(["background:", ";border-radius:12px;padding:20px;border:1px solid ", ";box-shadow:0px 1px 2px rgba(0,0,0,0.05);@media ", "{border:none;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile); // ── Field layout ────────────────────────────────────────────────────────

const FieldsRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__FieldsRow",
  componentId: "sc-1plgblb-1"
})(["display:flex;flex-wrap:wrap;gap:16px;align-items:flex-start;@media ", "{flex-direction:column;gap:12px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const FieldItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__FieldItem",
  componentId: "sc-1plgblb-2"
})(["flex:1 1 180px;min-width:0;@media ", "{flex:1 1 100%;width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const DateFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__DateFieldWrapper",
  componentId: "sc-1plgblb-3"
})(["flex:0 0 auto;width:200px;@media ", "{width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const FieldsFooter = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__FieldsFooter",
  componentId: "sc-1plgblb-4"
})(["display:flex;justify-content:flex-end;width:100%;margin-top:4px;"]); // ── Grid layout (used by AddNomineeModal) ───────────────────────────────

const FieldsGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__FieldsGrid",
  componentId: "sc-1plgblb-5"
})(["display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:16px;@media ", "{grid-template-columns:1fr;gap:12px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile); // ── Radio / Gender ──────────────────────────────────────────────────────

const GenderRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__GenderRow",
  componentId: "sc-1plgblb-6"
})(["display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:16px;@media ", "{flex-direction:column;gap:12px;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const RadioFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__RadioFieldWrapper",
  componentId: "sc-1plgblb-7"
})(["flex:0 0 auto;@media ", "{flex:1 1 100%;width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const GenderSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__GenderSection",
  componentId: "sc-1plgblb-8"
})(["flex:1;"]);
const GenderTypeItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__GenderTypeItem",
  componentId: "sc-1plgblb-9"
})(["background:", ";border:1px solid ", ";border-radius:6px;padding:0 12px;cursor:pointer;height:44px;display:flex;align-items:center;justify-content:center;", ""], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightGreyText */ .rS.lightGreyText, p => p.selected && `
    background: var(--tm-accent-bg-color);
    border: 1px solid ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText};
    border-width: 1px;
    border-radius: 6px;
`);
const ModalRadioButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__ModalRadioButtonStyle",
  componentId: "sc-1plgblb-10"
})(["display:flex;align-items:center;width:100%;label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;align-items:center;color:", ";width:100%;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:50%;transform:translateY(-50%);width:15px;height:15px;border:1px solid var(--tm-accent-color);border-radius:100%;background:", ";}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:var(--tm-accent-color);position:absolute;top:50%;left:3px;transform:translateY(-50%);border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:translateY(-50%) scale(0);transform:translateY(-50%) scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:translateY(-50%) scale(1);transform:translateY(-50%) scale(1);}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText3 */ .rS.greyText3, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText); // ── Dynamic fields ──────────────────────────────────────────────────────

const DynamicFieldTrigger = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__DynamicFieldTrigger",
  componentId: "sc-1plgblb-11"
})(["display:flex;align-items:center;align-self:flex-end;margin-top:8px;@media ", "{align-self:flex-start;}"], _utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const AddressFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__AddressFieldWrapper",
  componentId: "sc-1plgblb-12"
})(["margin-top:16px;width:100%;display:block;"]); // ── Error banner ────────────────────────────────────────────────────────

const ErrorBanner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FormRendererstyle__ErrorBanner",
  componentId: "sc-1plgblb-13"
})(["background:", ";border:1px solid ", ";border-radius:8px;padding:12px 16px;margin-top:16px;display:flex;align-items:center;gap:8px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightRed */ .rS.lightRed, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightRed */ .rS.lightRed);
const ErrorIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "FormRendererstyle__ErrorIcon",
  componentId: "sc-1plgblb-14"
})(["flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);

/***/ }),

/***/ 23567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": () => (/* binding */ normalizeFormConfig),
/* harmony export */   "Hn": () => (/* binding */ convertDDMMYYYYToYYYYMMDD),
/* harmony export */   "Mb": () => (/* binding */ minDate),
/* harmony export */   "OP": () => (/* binding */ validateField),
/* harmony export */   "ej": () => (/* binding */ convertYYYYMMDDToDDMMYYYY),
/* harmony export */   "l7": () => (/* binding */ maxDate)
/* harmony export */ });
/* unused harmony export normalizeFields */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62663);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// ── Date constants ──────────────────────────────────────────────────────
const minDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .subtractYrsFromDate */ .rv)(new Date(), 70).toISOString().split("T")[0];
const maxDate = new Date().toISOString().split("T")[0]; // ── Date conversions ────────────────────────────────────────────────────

const convertDDMMYYYYToYYYYMMDD = dateStr => {
  if (!dateStr) return "";
  const parts = dateStr.split("/");

  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return dateStr;
};
const convertYYYYMMDDToDDMMYYYY = dateStr => {
  if (!dateStr) return "";
  if (dateStr.includes("/")) return dateStr;
  const parts = dateStr.split("-");

  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  }

  return dateStr;
}; // ── Field validation ────────────────────────────────────────────────────

const validateField = (value, field) => {
  if (!field.validation) return "";

  if (field.isRequired && (!value || value.trim() === "")) {
    return field.validation.errorMessage || "This field is required";
  }

  if (value && field.type === "DATE" && field.validation.pattern) {
    let dateValue = value;

    if (value.includes("-") && value.length === 10) {
      const dateObj = new Date(value);

      if (isNaN(dateObj.getTime())) {
        return field.validation.errorMessage || "Invalid date";
      }

      dateValue = dateObj;
    } else if (value.includes("/")) {
      const parts = value.split("/");

      if (parts.length === 3) {
        const [day, month, year] = parts;
        const dateObj = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);

        if (isNaN(dateObj.getTime())) {
          return field.validation.errorMessage || "Invalid date";
        }

        dateValue = dateObj;
      }
    }

    const pattern = field.validation.pattern.replace(/\\\\/g, "\\");
    const isValid = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDobValid */ .qP)(dateValue, pattern);

    if (!isValid) {
      return field.validation.errorMessage || "Invalid date";
    }
  } else if (value && field.validation.pattern) {
    const pattern = field.validation.pattern.replace(/\\\\/g, "\\");
    const regex = new RegExp(pattern);

    if (!regex.test(value)) {
      return field.validation.errorMessage || "Invalid value";
    }
  }

  return "";
}; // ── Normalization (API sends fields as array OR object map) ─────────────

const normalizeFields = fields => {
  if (!fields) return [];
  if (Array.isArray(fields)) return fields;
  return Object.entries(fields).map(([key, value]) => _objectSpread(_objectSpread({}, value), {}, {
    name: value.name ?? key
  }));
};
const normalizeFormConfig = raw => _objectSpread(_objectSpread({}, raw), {}, {
  fields: normalizeFields(raw.fields),
  dynamicFields: raw.dynamicFields?.map(df => _objectSpread(_objectSpread({}, df), {}, {
    fields: normalizeFields(df.fields)
  }))
});

/***/ }),

/***/ 42105:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ec": () => (/* reexport */ FormRenderer_style/* FormCard */.Ec),
  "vo": () => (/* reexport */ FormRendererFields),
  "ej": () => (/* reexport */ formUtils/* convertYYYYMMDDToDDMMYYYY */.ej),
  "A$": () => (/* reexport */ formUtils/* normalizeFormConfig */.A$),
  "OS": () => (/* reexport */ useFormRenderer)
});

// UNUSED EXPORTS: AddressFieldWrapper, DateFieldWrapper, DynamicFieldTrigger, ErrorBanner, ErrorIcon, FieldItem, FieldsFooter, FieldsGrid, FieldsRow, GenderRow, GenderSection, GenderTypeItem, ModalRadioButtonStyle, RadioFieldWrapper, convertDDMMYYYYToYYYYMMDD, maxDate, minDate, normalizeFields, validateField

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/FormRenderer.style.ts
var FormRenderer_style = __webpack_require__(47560);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddressInput/AddressInput.style.ts



const AddressInputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddressInputstyle__AddressInputWrap",
  componentId: "sc-1vr39tp-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:100%;"], props => props.margin || "0");
const AddressInputLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "AddressInputstyle__AddressInputLabel",
  componentId: "sc-1vr39tp-1"
})(["font-weight:700;font-size:14px;line-height:16px;color:", ";display:block;margin-bottom:8px;transition:all 0.3s ease;"], Global/* theme.greyText */.rS.greyText);
const AddressInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddressInputstyle__AddressInputContainer",
  componentId: "sc-1vr39tp-2"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);
const AddressInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "AddressInputstyle__AddressInputStyle",
  componentId: "sc-1vr39tp-3"
})(["background:", ";border:1px solid ", ";border-radius:8px;padding:10px 12px;font-weight:400;font-size:16px;line-height:19px;flex:1;height:44px;color:", ";transition:all 0.2s ease;&::placeholder{font-weight:400;color:", ";}&:focus{outline:none;border:1px solid ", ";background:", ";}&:disabled{opacity:0.6;cursor:not-allowed;background:", ";border-color:", ";}@media ", "{width:100%;}"], props => props.disabled ? Global/* theme.smokeWhite */.rS.smokeWhite : Global/* theme.whiteText */.rS.whiteText, props => {
  if (props.hasError) return Global/* theme.redText2 */.rS.redText2;
  return Global/* theme.lightGreyText */.rS.lightGreyText;
}, Global/* theme.blackText */.rS.blackText, Global/* theme.lightBlack */.rS.lightBlack, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.smokeWhite */.rS.smokeWhite, Global/* theme.lightGreyText */.rS.lightGreyText, utils/* deviceType.mobile */.vO.mobile);
const CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "AddressInputstyle__CloseButton",
  componentId: "sc-1vr39tp-4"
})(["background:transparent;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;width:20px;height:20px;flex-shrink:0;transition:opacity 0.2s ease;&:hover{opacity:0.7;}&:active{opacity:0.5;}&:focus{outline:none;}img{width:100%;height:100%;object-fit:contain;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddressInput/AddressInput.tsx






const AddressInput = /*#__PURE__*/react.forwardRef(({
  placeholderTxt,
  labelTxt,
  margin,
  errorState,
  inputValue,
  handleChange,
  requiredField,
  handleKeyDown,
  maxInputLength,
  inputType,
  handleFocus,
  handleBlur,
  autoComplete = "on",
  isDisabled,
  hasError = false,
  onClear,
  alwaysShowClearButton = false
}, ref) => {
  const handleMouseWheel = event => {
    event.preventDefault();
  };

  const showClearButton = Boolean((alwaysShowClearButton || Boolean(inputValue)) && !isDisabled && onClear);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddressInputWrap, {
    margin: margin,
    "data-test-id": "AddressInput-AddressInputWrap",
    children: [labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddressInputLabel, {
      "data-test-id": "AddressInput-AddressInputLabel",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "AddressInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AddressInputContainer, {
      "data-test-id": "AddressInput-AddressInputContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AddressInputStyle, {
        ref: ref,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        value: inputValue,
        hasError: hasError,
        placeholder: placeholderTxt,
        maxLength: maxInputLength,
        type: inputType || "text",
        onWheel: handleMouseWheel,
        autoComplete: autoComplete,
        disabled: isDisabled,
        hasClearButton: showClearButton,
        "data-test-id": "AddressInput-AddressInputStyle"
      }), showClearButton && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
        type: "button",
        onClick: e => {
          e.preventDefault();
          e.stopPropagation();

          if (handleChange) {
            const syntheticEvent = {
              target: {
                value: ""
              }
            };
            handleChange(syntheticEvent);
          }

          if (onClear) {
            onClear();
          }
        },
        "aria-label": "Clear address",
        "data-test-id": "AddressInput-CloseButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "20px",
          height: "20px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
          "data-test-id": "AddressInput-ImageComponent"
        })
      })]
    })]
  });
});
AddressInput.displayName = "AddressInput";
/* harmony default export */ const AddressInput_AddressInput = (AddressInput);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddressInput/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormInput/index.ts + 2 modules
var FormInput = __webpack_require__(40050);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormSelect/FormSelect.style.ts



const FormSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FormSelectstyle__FormSelectWrap",
  componentId: "hryxgl-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";flex:", ";flex-shrink:0;width:100%;"], props => props.margin || "0", p => p.flex ? p.flex : "");
const FormSelectLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "FormSelectstyle__FormSelectLabel",
  componentId: "hryxgl-1"
})(["font-weight:700;font-size:14px;line-height:16px;color:", ";display:block;margin-bottom:8px;transition:all 0.3s ease;"], Global/* theme.greyText */.rS.greyText);
const FormSelectStyle = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
  displayName: "FormSelectstyle__FormSelectStyle",
  componentId: "hryxgl-2"
})(["background:", ";border:1px solid ", ";border-radius:8px;padding:10px 12px;font-weight:400;font-size:16px;line-height:19px;width:100%;height:44px;color:", ";transition:all 0.2s ease;cursor:", ";appearance:none;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23000000' d='M6 8L0 0h12z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 12px center;background-size:12px 8px;padding-right:36px;&::placeholder{font-weight:400;color:", ";}&:focus{outline:none;border:1px solid ", ";background-color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;background-color:", ";border-color:", ";}option{padding:8px;background:", ";color:", ";}@media ", "{width:100%;}"], props => props.disabled ? Global/* theme.smokeWhite */.rS.smokeWhite : props.backgroundColor || Global/* theme.whiteText */.rS.whiteText, props => {
  if (props.hasError) return Global/* theme.redText2 */.rS.redText2;
  return Global/* theme.lightGreyText */.rS.lightGreyText;
}, Global/* theme.blackText */.rS.blackText, props => props.disabled ? "not-allowed" : "pointer", Global/* theme.lightBlack */.rS.lightBlack, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.smokeWhite */.rS.smokeWhite, Global/* theme.lightGreyText */.rS.lightGreyText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormSelect/FormSelect.tsx







const FormSelect = ({
  placeholderTxt,
  labelTxt,
  margin,
  errorState,
  selectValue,
  handleChange,
  handleBlur,
  flex,
  requiredField,
  isDisabled,
  backgroundColor,
  hasError = false,
  showError = false,
  options = []
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormSelectWrap, {
    margin: margin,
    flex: flex,
    "data-test-id": "FormSelect-FormSelectWrap",
    children: [labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)(FormSelectLabel, {
      "data-test-id": "FormSelect-FormSelectLabel",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "FormSelect-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormSelectStyle, {
      onChange: handleChange,
      onBlur: handleBlur,
      value: selectValue || "",
      hasError: hasError,
      id: labelTxt,
      disabled: isDisabled,
      backgroundColor: backgroundColor,
      "data-test-id": "FormSelect-FormSelectStyle",
      children: [placeholderTxt && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "",
        disabled: true,
        "data-test-id": "FormSelect-option",
        children: placeholderTxt
      }), options.map(option => /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: option.value,
        "data-test-id": "FormSelect-option",
        children: option.label
      }, option.id))]
    }), showError && errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "xs",
      margin: "4px 0 0",
      color: Global/* theme.redText */.rS.redText,
      fontWeight: "bold",
      "data-test-id": "FormSelect-SpanTag",
      children: errorState
    })]
  });
};

/* harmony default export */ const FormSelect_FormSelect = (FormSelect);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormSelect/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/index.ts + 1 modules
var EditTravellersModal = __webpack_require__(40648);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/ModalRadioButton/ModalRadioButton.tsx





const ModalRadioButton = ({
  children,
  activeBtn,
  inputId,
  name = "radio-group"
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal/* ModalRadioButtonStyle */.l_, {
    "data-test-id": "ModalRadioButton-ModalRadioButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "radio",
      checked: activeBtn,
      id: inputId,
      name: name,
      readOnly: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      "data-test-id": "ModalRadioButton-label",
      children: children
    })]
  });
};

/* harmony default export */ const ModalRadioButton_ModalRadioButton = (ModalRadioButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/ModalRadioButton/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/formUtils.ts
var formUtils = __webpack_require__(23567);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/FormRendererFields.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









 // ── Props ───────────────────────────────────────────────────────────────





// ── Radio field sub-component ───────────────────────────────────────────
const RadioField = ({
  field,
  entityIndex,
  entityData,
  handleFieldChange
}) => {
  const fieldKey = field.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* RadioFieldWrapper */.mJ, {
    "data-test-id": "RadioField-RadioFieldWrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FormRenderer_style/* GenderSection */.bC, {
      "data-test-id": "RadioField-GenderSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
        margin: "0 0 8px",
        fontSize: "md",
        fontWeight: "bold",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "RadioField-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: field.label,
          "data-test-id": "RadioField-FormattedText"
        }), field.isRequired && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontWeight: "bold",
          color: Global/* theme.redText2 */.rS.redText2,
          "data-test-id": "RadioField-SpanTag",
          children: "*"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        gap: "8px",
        margin: "0",
        "data-test-id": "RadioField-FlexComp",
        children: field.options?.map(option => {
          const currentValue = String(entityData[fieldKey] || "").trim();
          const optionValue = String(option.value || "").trim();
          const isSelected = currentValue.toUpperCase() === optionValue.toUpperCase();
          const uniqueId = `${fieldKey}-${entityIndex}-${option.id}`;
          const uniqueName = `${fieldKey}-${entityIndex}`;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* GenderTypeItem */.OX, {
            selected: isSelected,
            onClick: () => {
              if (field.isEnabled) {
                handleFieldChange(entityIndex, fieldKey, option.value);
              }
            },
            "data-test-id": "RadioField-GenderTypeItem",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ModalRadioButton_ModalRadioButton, {
              activeBtn: isSelected,
              inputId: uniqueId,
              name: uniqueName,
              "data-test-id": "RadioField-ModalRadioButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: isSelected ? `var(--tm-accent-color)` : Global/* theme.greyText */.rS.greyText,
                "data-test-id": "RadioField-SpanTag",
                children: option.label
              })
            })
          }, option.id);
        })
      })]
    })
  });
}; // ── Dynamic fields sub-component ────────────────────────────────────────


const DynamicFieldsSection = ({
  dynamicField: df,
  entityIndex,
  entityData,
  entityErrors,
  getFieldRef,
  handleDynamicFieldChange,
  toggleDynamicField,
  setErrors
}) => {
  const isVisible = entityData.dynamicFields?.[df.triggerId]?.visible || false;
  if (!isVisible) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* AddressFieldWrapper */.Hi, {
    "data-test-id": "DynamicFieldsSection-AddressFieldWrapper",
    children: df.fields.map(field => {
      const fieldKey = field.name;
      const fieldError = entityErrors[`${df.triggerId}_${fieldKey}`];
      const fieldValue = String(entityData.dynamicFields?.[df.triggerId]?.[fieldKey] || "");
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AddressInput_AddressInput, {
        ref: getFieldRef(entityIndex, `${df.triggerId}_${fieldKey}`),
        labelTxt: field.label,
        placeholderTxt: field.placeholder,
        requiredField: field.isRequired,
        inputValue: fieldValue,
        errorState: fieldError,
        hasError: !!fieldError,
        isDisabled: !field.isEnabled,
        alwaysShowClearButton: true,
        handleChange: e => {
          handleDynamicFieldChange(entityIndex, df.triggerId, fieldKey, e.target.value);
        },
        handleBlur: e => {
          const error = (0,formUtils/* validateField */.OP)(e.target.value, field);
          setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
            [entityIndex]: _objectSpread(_objectSpread({}, prev[entityIndex]), {}, {
              [`${df.triggerId}_${fieldKey}`]: error
            })
          }));
        },
        onClear: () => {
          handleDynamicFieldChange(entityIndex, df.triggerId, fieldKey, "");
          toggleDynamicField(entityIndex, df.triggerId);
        },
        margin: "0 0 16px",
        "data-test-id": `DynamicFieldsSection-AddressInput-${fieldKey}`
      }, fieldKey);
    })
  });
}; // ── Select field helper ─────────────────────────────────────────────────


const SelectField = ({
  field,
  entityIndex,
  displayValue,
  entityErrors,
  handleFieldChange,
  setErrors
}) => {
  const fieldKey = field.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* FieldItem */.mZ, {
    "data-test-id": "SelectField-FieldItem",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormSelect_FormSelect, {
      flex: "1",
      labelTxt: field.label,
      placeholderTxt: field.placeholder,
      requiredField: field.isRequired,
      selectValue: displayValue,
      errorState: entityErrors[fieldKey],
      hasError: !!entityErrors[fieldKey],
      showError: false,
      isDisabled: !field.isEnabled,
      options: field.options || [],
      handleChange: e => {
        handleFieldChange(entityIndex, fieldKey, e.target.value);
      },
      handleBlur: e => {
        const error = (0,formUtils/* validateField */.OP)(e.target.value, field);
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [entityIndex]: _objectSpread(_objectSpread({}, prev[entityIndex]), {}, {
            [fieldKey]: error
          })
        }));
      },
      margin: "0",
      "data-test-id": "SelectField-FormSelect"
    })
  });
}; // ── Main component ──────────────────────────────────────────────────────


const FormRendererFields = ({
  entityIndex,
  entityData,
  entityErrors,
  formConfig,
  getFieldRef,
  handleFieldChange,
  handleMaskedFocus,
  handleMaskedBlur,
  handleDynamicFieldChange,
  toggleDynamicField,
  setErrors
}) => {
  const hasErrors = Object.values(entityErrors).some(e => e);
  const visibleFields = formConfig.fields.filter(field => field.isVisible);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* FieldsRow */.cB, {
      "data-test-id": "FormRendererFields-FieldsRow",
      children: visibleFields.map(field => {
        const fieldKey = field.name;
        const displayValue = String(entityData[fieldKey] || ""); // RADIO

        if (field.type === "RADIO" && field.options) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioField, {
            field: field,
            entityIndex: entityIndex,
            entityData: entityData,
            handleFieldChange: handleFieldChange,
            "data-test-id": `FormRendererFields-RadioField-${fieldKey}`
          }, fieldKey);
        } // SELECT


        if (field.type === "SELECT") {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectField, {
            field: field,
            entityIndex: entityIndex,
            displayValue: displayValue,
            entityErrors: entityErrors,
            handleFieldChange: handleFieldChange,
            setErrors: setErrors,
            "data-test-id": `FormRendererFields-SelectField-${fieldKey}`
          }, fieldKey);
        } // DATE


        const isDateField = field.type === "DATE";

        if (isDateField) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* DateFieldWrapper */.bW, {
            "data-test-id": `FormRendererFields-DateFieldWrapper-${fieldKey}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
              ref: getFieldRef(entityIndex, fieldKey),
              flex: "1",
              labelTxt: field.label,
              placeholderTxt: field.placeholder,
              requiredField: field.isRequired,
              inputValue: displayValue,
              errorState: entityErrors[fieldKey],
              hasError: !!entityErrors[fieldKey],
              showError: false,
              isDisabled: !field.isEnabled,
              inputType: "date",
              minValue: formUtils/* minDate */.Mb,
              maxValue: formUtils/* maxDate */.l7,
              handleChange: e => {
                handleFieldChange(entityIndex, fieldKey, e.target.value);
              },
              handleBlur: e => {
                const error = (0,formUtils/* validateField */.OP)(e.target.value, field);
                setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
                  [entityIndex]: _objectSpread(_objectSpread({}, prev[entityIndex]), {}, {
                    [fieldKey]: error
                  })
                }));
              },
              margin: "0",
              "data-test-id": "FormRendererFields-FormInput"
            })
          }, fieldKey);
        } // TEXT (default)


        return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* FieldItem */.mZ, {
          "data-test-id": `FormRendererFields-FieldItem-${fieldKey}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
            ref: getFieldRef(entityIndex, fieldKey),
            flex: "1",
            labelTxt: field.label,
            placeholderTxt: field.placeholder,
            requiredField: field.isRequired,
            inputValue: displayValue,
            errorState: entityErrors[fieldKey],
            hasError: !!entityErrors[fieldKey],
            showError: false,
            isDisabled: !field.isEnabled,
            inputType: "text",
            handleChange: e => {
              handleFieldChange(entityIndex, fieldKey, e.target.value);
            },
            handleFocus: field.isMasked ? () => handleMaskedFocus(entityIndex, fieldKey) : undefined,
            handleBlur: e => {
              if (field.isMasked) {
                handleMaskedBlur(entityIndex, fieldKey, e.target.value, field);
              } else {
                const error = (0,formUtils/* validateField */.OP)(e.target.value, field);
                setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
                  [entityIndex]: _objectSpread(_objectSpread({}, prev[entityIndex]), {}, {
                    [fieldKey]: error
                  })
                }));
              }
            },
            margin: "0",
            "data-test-id": "FormRendererFields-FormInput"
          })
        }, fieldKey);
      })
    }), formConfig.dynamicFields?.some(df => df.trigger.isVisible && !entityData.dynamicFields?.[df.triggerId]?.visible) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* FieldsFooter */.Wt, {
      "data-test-id": "FormRendererFields-FieldsFooter",
      children: formConfig.dynamicFields?.map(df => {
        if (!df.trigger.isVisible) return null;
        const isVisible = entityData.dynamicFields?.[df.triggerId]?.visible || false;
        if (isVisible) return null;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* DynamicFieldTrigger */.mf, {
          "data-test-id": "FormRendererFields-DynamicFieldTrigger",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
            fontWeight: "bold",
            handleClick: () => {
              toggleDynamicField(entityIndex, df.triggerId);
            },
            "data-test-id": "FormRendererFields-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: df.trigger.label,
              "data-test-id": "FormRendererFields-FormattedText"
            })
          })
        }, df.triggerId);
      })
    }), formConfig.dynamicFields?.map(df => {
      if (!df.trigger.isVisible) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicFieldsSection, {
        dynamicField: df,
        entityIndex: entityIndex,
        entityData: entityData,
        entityErrors: entityErrors,
        getFieldRef: getFieldRef,
        handleDynamicFieldChange: handleDynamicFieldChange,
        toggleDynamicField: toggleDynamicField,
        setErrors: setErrors,
        "data-test-id": "FormRendererFields-DynamicFieldsSection"
      }, df.triggerId);
    }), hasErrors && /*#__PURE__*/(0,jsx_runtime.jsxs)(FormRenderer_style/* ErrorBanner */.H4, {
      "data-test-id": "FormRendererFields-ErrorBanner",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer_style/* ErrorIcon */.Pz, {
        "data-test-id": "FormRendererFields-ErrorIcon",
        children: "\u26A0"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "FormRendererFields-SpanTag",
        children: Object.values(entityErrors).filter(e => e).join(". ")
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/useFormRenderer.ts


function useFormRenderer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFormRenderer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFormRenderer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFormRenderer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // ── Types ───────────────────────────────────────────────────────────────

// ── Hook ────────────────────────────────────────────────────────────────
const useFormRenderer = ({
  isOpen,
  formConfig,
  entities,
  extractEntityData
}) => {
  const {
    0: formData,
    1: setFormData
  } = (0,react.useState)([]);
  const {
    0: errors,
    1: setErrors
  } = (0,react.useState)({});
  const initialDataRef = (0,react.useRef)([]);
  const prevIsOpenRef = (0,react.useRef)(false);
  const fieldRefs = (0,react.useRef)({}); // ── Refs ────────────────────────────────────────────────────────────

  const getFieldRef = (entityIndex, fieldKey) => {
    if (!fieldRefs.current[entityIndex]) {
      fieldRefs.current[entityIndex] = {};
    }

    if (!fieldRefs.current[entityIndex][fieldKey]) {
      fieldRefs.current[entityIndex][fieldKey] = /*#__PURE__*/react.createRef();
    }

    return fieldRefs.current[entityIndex][fieldKey];
  }; // ── Initialization ──────────────────────────────────────────────────


  (0,react.useEffect)(() => {
    if (isOpen && entities.length > 0) {
      prevIsOpenRef.current = true;
      const initialData = entities.map(entity => {
        const raw = extractEntityData(entity);
        const data = {};
        formConfig.fields.forEach(field => {
          const fieldKey = field.name;
          let value = raw[fieldKey] || "";

          if (field.type === "DATE" && value) {
            value = (0,formUtils/* convertDDMMYYYYToYYYYMMDD */.Hn)(String(value));
          } else if (field.type === "RADIO" || field.type === "SELECT") {
            value = String(value || "").trim();
          } else {
            value = String(value || "");
          }

          data[fieldKey] = value;
        });
        const dynamicFieldsState = {};
        formConfig.dynamicFields?.forEach(df => {
          const firstField = df.fields[0];
          const firstFieldKey = firstField?.name;
          const hasExistingValue = firstFieldKey ? Boolean(raw[firstFieldKey]) : false;
          const shouldBeVisible = firstField?.isVisible || hasExistingValue;
          dynamicFieldsState[df.triggerId] = {
            visible: shouldBeVisible
          };
          df.fields.forEach(field => {
            dynamicFieldsState[df.triggerId][field.name] = raw[field.name] || "";
          });
        });
        data.dynamicFields = dynamicFieldsState;
        return data;
      });
      setFormData(initialData);
      setErrors({});
      initialDataRef.current = JSON.parse(JSON.stringify(initialData));
    } else if (!isOpen) {
      prevIsOpenRef.current = false;
    }
  }, [isOpen, entities, formConfig]); // ── Masked field helpers ────────────────────────────────────────────

  const getInitialValue = (entityIndex, fieldKey) => String(initialDataRef.current[entityIndex]?.[fieldKey] ?? "");

  const handleMaskedFocus = (entityIndex, fieldKey) => {
    setFormData(prev => {
      const updated = [...prev];
      updated[entityIndex] = useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, updated[entityIndex]), {}, {
        [fieldKey]: ""
      });
      return updated;
    });
  };

  const handleMaskedBlur = (entityIndex, fieldKey, currentValue, field) => {
    if (!currentValue.trim()) {
      const maskedValue = getInitialValue(entityIndex, fieldKey);
      setFormData(prev => {
        const updated = [...prev];
        updated[entityIndex] = useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, updated[entityIndex]), {}, {
          [fieldKey]: maskedValue
        });
        return updated;
      });
      setErrors(prev => useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev), {}, {
        [entityIndex]: useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev[entityIndex]), {}, {
          [fieldKey]: ""
        })
      }));
      return;
    }

    const error = (0,formUtils/* validateField */.OP)(currentValue, field);
    setErrors(prev => useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev), {}, {
      [entityIndex]: useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev[entityIndex]), {}, {
        [fieldKey]: error
      })
    }));
  }; // ── Field change handlers ──────────────────────────────────────────


  const handleFieldChange = (entityIndex, fieldKey, value) => {
    setFormData(prev => {
      const updated = [...prev];
      updated[entityIndex] = useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, updated[entityIndex]), {}, {
        [fieldKey]: value
      });
      return updated;
    });
    const field = formConfig.fields.find(f => f.name === fieldKey);

    if (field) {
      const error = (0,formUtils/* validateField */.OP)(value, field);
      setErrors(prev => useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev), {}, {
        [entityIndex]: useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev[entityIndex]), {}, {
          [fieldKey]: error
        })
      }));
    }
  };

  const handleDynamicFieldChange = (entityIndex, triggerId, fieldKey, value) => {
    setFormData(prev => {
      const updated = [...prev];

      const entity = useFormRenderer_objectSpread({}, updated[entityIndex]);

      const dynamicFields = useFormRenderer_objectSpread({}, entity.dynamicFields);

      dynamicFields[triggerId] = useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, dynamicFields[triggerId] || {
        visible: false
      }), {}, {
        [fieldKey]: value
      });
      entity.dynamicFields = dynamicFields;
      updated[entityIndex] = entity;
      return updated;
    });
    const dynamicField = formConfig.dynamicFields?.find(df => df.triggerId === triggerId);
    const field = dynamicField?.fields.find(f => f.name === fieldKey);

    if (field) {
      const error = (0,formUtils/* validateField */.OP)(value, field);
      setErrors(prev => useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev), {}, {
        [entityIndex]: useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, prev[entityIndex]), {}, {
          [`${triggerId}_${fieldKey}`]: error
        })
      }));
    }
  };

  const toggleDynamicField = (entityIndex, triggerId) => {
    const dynamicFieldConfig = formConfig.dynamicFields?.find(df => df.triggerId === triggerId);
    setFormData(prev => {
      const updated = [...prev];

      const entity = useFormRenderer_objectSpread({}, updated[entityIndex]);

      const dynamicFields = useFormRenderer_objectSpread({}, entity.dynamicFields);

      const currentVisibility = dynamicFields[triggerId]?.visible || false;
      const newVisibility = !currentVisibility;

      const triggerState = useFormRenderer_objectSpread(useFormRenderer_objectSpread({}, dynamicFields[triggerId] || {}), {}, {
        visible: newVisibility
      });

      if (!newVisibility && dynamicFieldConfig) {
        dynamicFieldConfig.fields.forEach(field => {
          triggerState[field.name] = "";
        });
      }

      if (newVisibility && !dynamicFields[triggerId] && dynamicFieldConfig) {
        dynamicFieldConfig.fields.forEach(field => {
          triggerState[field.name] = "";
        });
      }

      dynamicFields[triggerId] = triggerState;
      entity.dynamicFields = dynamicFields;
      updated[entityIndex] = entity;
      return updated;
    });

    if (dynamicFieldConfig) {
      setErrors(prev => {
        const updatedErrors = useFormRenderer_objectSpread({}, prev);

        if (updatedErrors[entityIndex]) {
          const entityErrors = useFormRenderer_objectSpread({}, updatedErrors[entityIndex]);

          dynamicFieldConfig.fields.forEach(field => {
            delete entityErrors[`${triggerId}_${field.name}`];
          });

          if (Object.keys(entityErrors).length === 0) {
            delete updatedErrors[entityIndex];
          } else {
            updatedErrors[entityIndex] = entityErrors;
          }
        }

        return updatedErrors;
      });
    }
  }; // ── Scroll to error ────────────────────────────────────────────────


  const scrollToFirstError = errorMap => {
    const indices = Object.keys(errorMap).map(Number).sort((a, b) => a - b);

    for (const entityIndex of indices) {
      const entityErrors = errorMap[entityIndex];
      if (!entityErrors) continue;
      const firstErrorKey = Object.keys(entityErrors).find(key => entityErrors[key]);
      if (!firstErrorKey) continue;
      const fieldRef = fieldRefs.current[entityIndex]?.[firstErrorKey];

      if (fieldRef?.current) {
        fieldRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        setTimeout(() => fieldRef.current?.focus(), 300);
        return;
      }
    }
  }; // ── Validation ─────────────────────────────────────────────────────


  const validateAllFields = entityFilter => {
    const newErrors = {};
    let isValid = true;
    formData.forEach((entityData, entityIndex) => {
      if (entityFilter && !entityFilter(entityIndex)) return;
      formConfig.fields.forEach(field => {
        const fieldKey = field.name;
        if (!field.isVisible || !field.isEnabled) return;
        const value = String(entityData[fieldKey] || ""); // Skip validation for masked fields that haven't been changed

        if (field.isMasked && value === getInitialValue(entityIndex, fieldKey)) return;
        const error = (0,formUtils/* validateField */.OP)(value, field);

        if (error) {
          isValid = false;
          if (!newErrors[entityIndex]) newErrors[entityIndex] = {};
          newErrors[entityIndex][fieldKey] = error;
        }
      });
      formConfig.dynamicFields?.forEach(df => {
        const isVisible = entityData.dynamicFields?.[df.triggerId]?.visible || false;
        if (!isVisible) return;
        df.fields.forEach(field => {
          if (!field.isEnabled) return;
          const fieldKey = field.name;
          const value = String(entityData.dynamicFields?.[df.triggerId]?.[fieldKey] || "");
          const error = (0,formUtils/* validateField */.OP)(value, field);

          if (error) {
            isValid = false;
            if (!newErrors[entityIndex]) newErrors[entityIndex] = {};
            newErrors[entityIndex][`${df.triggerId}_${fieldKey}`] = error;
          }
        });
      });
    });
    setErrors(newErrors);

    if (!isValid) {
      setTimeout(() => scrollToFirstError(newErrors), 100);
    }

    return isValid;
  }; // ── Change detection ───────────────────────────────────────────────


  const hasFormDataChanged = entityFilter => {
    if (initialDataRef.current.length === 0 || formData.length === 0 || initialDataRef.current.length !== formData.length) {
      return initialDataRef.current.length !== formData.length;
    }

    for (let i = 0; i < formData.length; i++) {
      if (entityFilter && !entityFilter(i)) continue;
      const current = formData[i];
      const initial = initialDataRef.current[i];

      for (const field of formConfig.fields) {
        const fieldKey = field.name;

        if (String(current[fieldKey] || "").trim() !== String(initial[fieldKey] || "").trim()) {
          return true;
        }
      }

      if (formConfig.dynamicFields) {
        for (const df of formConfig.dynamicFields) {
          const currentDynamic = current.dynamicFields?.[df.triggerId];
          const initialDynamic = initial.dynamicFields?.[df.triggerId];
          if (currentDynamic?.visible !== initialDynamic?.visible) return true;

          if (currentDynamic?.visible) {
            for (const field of df.fields) {
              const fieldKey = field.name;

              if (String(currentDynamic[fieldKey] || "").trim() !== String(initialDynamic?.[fieldKey] || "").trim()) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  };

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    initialDataRef,
    getFieldRef,
    getInitialValue,
    handleFieldChange,
    handleMaskedFocus,
    handleMaskedBlur,
    handleDynamicFieldChange,
    toggleDynamicField,
    validateAllFields,
    hasFormDataChanged,
    scrollToFirstError
  };
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/index.ts





/***/ }),

/***/ 7125:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* reexport */ InfoModalContent)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/InfoModalContent/InfoModalContent.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







// ── Static styles ───────────────────────────────────────────────────────
const resultContentStyle = {
  textAlign: "center",
  color: Global/* theme.greyText */.rS.greyText,
  fontSize: "14px",
  lineHeight: "1.4"
};

const resultTitleStyle = _objectSpread(_objectSpread({}, resultContentStyle), {}, {
  fontWeight: 700,
  fontSize: "18px",
  marginBottom: "8px"
});

const resultSubtitleStyle = _objectSpread(_objectSpread({}, resultContentStyle), {}, {
  color: Global/* theme.greyText7 */.rS.greyText7,
  marginBottom: "4px"
});

const resultDescStyle = _objectSpread(_objectSpread({}, resultContentStyle), {}, {
  color: Global/* theme.greyText7 */.rS.greyText7,
  fontSize: "13px",
  marginBottom: "16px"
}); // ── Helpers ──────────────────────────────────────────────────────────────


const HtmlBlock = ({
  html,
  style
}) => html ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
  style: style,
  "data-test-id": "HtmlBlock",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
    value: {
      html
    },
    "data-test-id": "HtmlBlock-FormattedText"
  })
}) : null; // ── Component ───────────────────────────────────────────────────────────


const InfoModalContent = ({
  viewType,
  data,
  onRetry,
  defaultSuccessIcon,
  renderAction
}) => {
  if (!data) return null;
  const {
    icon,
    title,
    subtitle,
    desc
  } = data;

  if (viewType === "success") {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      flexDirection: "column",
      alignItems: "center",
      gap: "0",
      margin: "0 0 24px",
      "data-test-id": "InfoModalContent-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: icon || defaultSuccessIcon || constants/* ORDER_DETAIL_V2_ASSETS.SUCCESS_ICON */.XK.SUCCESS_ICON,
        width: "56",
        height: "56",
        alt: "Success",
        margin: "0 auto 16px",
        "data-test-id": "InfoModalContent-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: title,
        style: resultTitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: subtitle,
        style: resultSubtitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: desc,
        style: resultDescStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), renderAction ? renderAction(data) : null]
    });
  }

  if (viewType === "error") {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      flexDirection: "column",
      alignItems: "center",
      gap: "0",
      margin: "0 0 24px",
      "data-test-id": "InfoModalContent-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: title,
        style: resultTitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: subtitle,
        style: resultSubtitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: desc,
        style: resultDescStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), renderAction ? renderAction(data) : onRetry && data.cta?.isEnabled !== false && data.cta?.label ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: onRetry,
        style: {
          marginTop: "16px",
          cursor: "pointer"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: data.cta.label,
          "data-test-id": "InfoModalContent-FormattedText"
        })
      }) : null]
    });
  }

  if (viewType === "generating") {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      flexDirection: "column",
      alignItems: "center",
      gap: "0",
      margin: "0 0 24px",
      "data-test-id": "InfoModalContent-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: title,
        style: resultTitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: subtitle,
        style: resultSubtitleStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HtmlBlock, {
        html: desc,
        style: resultDescStyle,
        "data-test-id": "InfoModalContent-HtmlBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        margin: "16px 0 0",
        "data-test-id": "InfoModalContent-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.Spinner, {
          spinnerWidth: 32,
          spinnerColor: Global/* theme.blueText */.rS.blueText,
          thickness: 2,
          "data-test-id": "InfoModalContent-Spinner"
        })
      })]
    });
  }

  return null;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/InfoModalContent/index.ts


/***/ }),

/***/ 11941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* reexport */ OrderDetailV2Contact)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Context.tsx
var OrderDetailV2Context = __webpack_require__(23027);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/EditTravellersModal.style.ts
var EditTravellersModal_style = __webpack_require__(96542);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormInput/index.ts + 2 modules
var FormInput = __webpack_require__(40050);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/InfoModalContent/index.ts + 1 modules
var InfoModalContent = __webpack_require__(7125);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/index.ts + 2 modules
var TextButton = __webpack_require__(60313);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddAlternateContactModal/AddAlternateContactModal.style.ts



const ContactFormSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__ContactFormSection",
  componentId: "sc-1wyymxv-0"
})(["display:flex;flex-direction:column;gap:20px;padding-bottom:24px;max-height:calc(100vh - 200px);overflow-y:auto;overflow-x:hidden;@media ", "{max-height:calc(100vh - 180px);padding:16px 0;}"], utils/* deviceType.mobile */.vO.mobile);
const ContactFormFields = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__ContactFormFields",
  componentId: "sc-1wyymxv-1"
})(["display:flex;flex-direction:column;gap:16px;"]);
const ModalFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__ModalFooter",
  componentId: "sc-1wyymxv-2"
})(["position:sticky;bottom:0;background:", ";padding:0;margin:auto -30px 0 -30px;border-top:1px solid ", ";display:flex;flex-direction:column;z-index:10;@media ", "{margin:auto -30px 0 -30px;}"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.lightSilver */.rS.lightSilver, utils/* deviceType.mobile */.vO.mobile);
const FooterButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__FooterButtonRow",
  componentId: "sc-1wyymxv-3"
})(["display:flex;justify-content:space-between;align-items:center;padding:16px 30px;gap:12px;@media ", "{flex-direction:column-reverse;padding:16px;}"], utils/* deviceType.mobile */.vO.mobile);
const FooterLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__FooterLeft",
  componentId: "sc-1wyymxv-4"
})(["display:flex;align-items:center;gap:12px;"]);
const FooterRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactModalstyle__FooterRight",
  componentId: "sc-1wyymxv-5"
})(["display:flex;align-items:center;gap:12px;"]);
const SaveButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "AddAlternateContactModalstyle__SaveButton",
  componentId: "sc-1wyymxv-6"
})(["padding:12px 32px;background:", ";color:", ";border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:", ";transition:all 0.2s;min-width:140px;text-transform:uppercase;letter-spacing:0.5px;display:flex;align-items:center;justify-content:center;gap:8px;&:hover{background:", ";}&:disabled{background:", ";cursor:not-allowed;}@media ", "{width:100%;padding:14px 32px;}"], props => {
  if (props.isLoading) return Global/* theme.blueText */.rS.blueText;
  if (props.hasChanges) return Global/* theme.blueText */.rS.blueText;
  return Global/* theme.greyText2 */.rS.greyText2;
}, Global/* theme.whiteText */.rS.whiteText, props => props.hasChanges && !props.isLoading ? "pointer" : "not-allowed", props => {
  if (props.isLoading || !props.hasChanges) return props.hasChanges ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText2 */.rS.greyText2;
  return Global/* theme.prussianBlue */.rS.prussianBlue;
}, Global/* theme.greyText2 */.rS.greyText2, utils/* deviceType.mobile */.vO.mobile);
const ModalSubtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "AddAlternateContactModalstyle__ModalSubtitle",
  componentId: "sc-1wyymxv-7"
})(["margin:0;font-size:14px;line-height:20px;color:", ";font-weight:400;"], Global/* theme.greyText */.rS.greyText);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddAlternateContactModal/AddAlternateContactModal.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















const FIELD_ORDER = {
  name: 1,
  phone: 2,
  email: 3
};

const validateField = (value, field) => {
  if (!field.validation) return "";

  if (field.isRequired && (!value || value.trim() === "")) {
    return field.validation.errorMessage || "This field is required";
  }

  if (value && field.validation.pattern) {
    const pattern = field.validation.pattern.replace(/\\\\/g, "\\");
    const regex = new RegExp(pattern);

    if (!regex.test(value)) {
      return field.validation.errorMessage || "Invalid value";
    }
  }

  return "";
};

const AddAlternateContactModal = ({
  isOpen,
  onClose,
  formConfig,
  modalConfig,
  initialValues,
  bookingId,
  primaryEntity,
  onSave,
  onEndorsementSuccess
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: formData,
    1: setFormData
  } = (0,react.useState)({
    name: "",
    email: "",
    phone: ""
  });
  const {
    0: errors,
    1: setErrors
  } = (0,react.useState)({});
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: endorsementView,
    1: setEndorsementView
  } = (0,react.useState)("form");
  const {
    0: endorsementData,
    1: setEndorsementData
  } = (0,react.useState)(null);
  const {
    0: apiErrorMessage,
    1: setApiErrorMessage
  } = (0,react.useState)(null);
  const initialDataRef = (0,react.useRef)({});
  const prevIsOpenRef = (0,react.useRef)(false);
  const pendingRefreshRef = (0,react.useRef)(false);
  const header = modalConfig?.header || {};
  const footerCtas = modalConfig?.footer?.cta || [];
  const backCta = footerCtas.find(c => c?.actionId === "CLOSE_FORM");
  const saveCta = footerCtas.find(c => c?.actionId === "SAVE_CONTACT");
  const fields = formConfig?.fields ? Object.entries(formConfig.fields).filter(([, f]) => f?.isVisible !== false).sort(([a], [b]) => (FIELD_ORDER[a] ?? 99) - (FIELD_ORDER[b] ?? 99)) : [];
  (0,react.useEffect)(() => {
    if (isOpen) {
      const isModalJustOpened = !prevIsOpenRef.current;
      prevIsOpenRef.current = true;
      const initial = {
        name: initialValues?.name ?? "",
        email: initialValues?.email ?? "",
        phone: initialValues?.phone ?? ""
      };
      setFormData(initial);
      setErrors({});
      initialDataRef.current = _objectSpread({}, initial);
      setIsLoading(false);

      if (isModalJustOpened) {
        setEndorsementView("form");
        setEndorsementData(null);
        setApiErrorMessage(null);
      }
    } else {
      prevIsOpenRef.current = false;
    }
  }, [isOpen, initialValues?.name, initialValues?.email, initialValues?.phone]); // Returns the initial (masked) value for a field from the snapshot taken when the modal opened

  const getInitialValue = fieldKey => String(initialDataRef.current[fieldKey] ?? "");

  const handleMaskedFocus = fieldKey => {
    // Clear the masked value so the user can type a fresh value
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [fieldKey]: ""
    }));
  };

  const handleMaskedBlur = (fieldKey, currentValue, field) => {
    // If the user didn't type anything, restore the original masked value
    if (!currentValue.trim()) {
      const maskedValue = getInitialValue(fieldKey);
      setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldKey]: maskedValue
      }));
      setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldKey]: ""
      }));
      return;
    } // User typed something new — run normal validation


    const error = validateField(currentValue, field);
    setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [fieldKey]: error
    }));
  };

  const handleFieldChange = (fieldKey, value) => {
    if (apiErrorMessage) setApiErrorMessage(null);
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [fieldKey]: value
    }));
    const field = formConfig?.fields?.[fieldKey];

    if (field) {
      const error = validateField(value, field);
      setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldKey]: error
      }));
    }
  };

  const hasFormDataChanged = () => {
    const initial = initialDataRef.current;
    return (formData.name ?? "") !== (initial.name ?? "") || (formData.email ?? "") !== (initial.email ?? "") || (formData.phone ?? "") !== (initial.phone ?? "");
  };

  const validateAllFields = () => {
    if (!formConfig?.fields) return true;
    const newErrors = {};
    let isValid = true;
    fields.forEach(([fieldKey, field]) => {
      if (field.isVisible && field.isEnabled) {
        const value = formData[fieldKey] ?? ""; // Skip validation for masked fields that haven't been changed

        if (field.isMasked && value === getInitialValue(fieldKey)) return;
        const error = validateField(value, field);

        if (error) {
          isValid = false;
          newErrors[fieldKey] = error;
        }
      }
    });
    setErrors(newErrors);
    return isValid;
  };

  const handleSave = async () => {
    if (!validateAllFields()) return;
    setIsLoading(true);

    try {
      if (!primaryEntity) {
        throw new Error("Primary entity is required");
      }

      const payload = [_objectSpread(_objectSpread({
        entityId: primaryEntity.id
      }, primaryEntity.data), {}, {
        alternateContactNo: formData.phone ?? "",
        alternateEmail: formData.email ?? ""
      })];
      const res = await (0,api/* submitEndorsement */.Yh)({
        bookingId,
        payload
      });
      setEndorsementData(res);
      const status = (res?.status ?? "").toUpperCase();

      if (status === "SUCCESS") {
        setEndorsementView("success");
        setApiErrorMessage(null);
        initialDataRef.current = _objectSpread({}, formData);
        await Promise.resolve(onSave({
          name: formData.name,
          email: formData.email,
          phone: formData.phone
        }));
        pendingRefreshRef.current = true;
      } else if (status === "ERROR" || status === "VALIDATION_ERROR") {
        setApiErrorMessage(res?.desc || res?.subtitle || res?.title || "An error occurred. Please try again.");
        setEndorsementView("form");
      } else {
        setEndorsementView("generating");
      }
    } catch {
      setApiErrorMessage("An error occurred. Please try again.");
      setEndorsementView("form");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (pendingRefreshRef.current) {
      pendingRefreshRef.current = false;
      onEndorsementSuccess?.();
    }

    onClose();
  };

  if (!isOpen) return null;
  const modalTitle = header?.title ?? "Add Alternate Contact Details";
  const modalSubTitle = header?.subTitle;
  const backLabel = backCta?.label ?? "GO BACK";
  const saveLabel = saveCta?.label ?? "Save Details";
  const hasChanges = hasFormDataChanged();

  const renderResultView = () => /*#__PURE__*/(0,jsx_runtime.jsx)(ContactFormSection, {
    "data-test-id": "AddAlternateContactModal-renderResultView-ContactFormSection",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoModalContent/* InfoModalContent */.T, {
      viewType: endorsementView,
      data: endorsementData,
      renderAction: data => {
        if (endorsementView === "success" && data.cta?.isEnabled !== false && data.cta?.label && data.newPolicyUrl) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SaveButton, {
            as: "a",
            href: data.newPolicyUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            hasChanges: true,
            isLoading: false,
            style: {
              marginTop: "16px",
              textDecoration: "none"
            },
            "data-test-id": "AddAlternateContactModal-renderResultView-SaveButton",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: {
                text: {
                  value: data.cta.label
                }
              },
              "data-test-id": "AddAlternateContactModal-renderResultView-FormattedText"
            })
          });
        }

        return null;
      },
      "data-test-id": "AddAlternateContactModal-renderResultView-InfoModalContent"
    })
  });

  const isResultView = endorsementView === "success" || endorsementView === "generating";

  const isFormValid = () => {
    if (!formConfig?.fields || fields.length === 0) return false;

    for (const [fieldKey, field] of fields) {
      if (field.isVisible && field.isEnabled) {
        const value = formData[fieldKey] ?? ""; // Skip validation for masked fields that haven't been changed

        if (field.isMasked && value === getInitialValue(fieldKey)) continue;
        if (validateField(value, field)) return false;
      }
    }

    return true;
  };

  const canSave = hasChanges && isFormValid();

  const renderFormContent = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContactFormSection, {
      "data-test-id": "AddAlternateContactModal-renderFormContent-ContactFormSection",
      children: [modalSubTitle ? /*#__PURE__*/(0,jsx_runtime.jsx)(ModalSubtitle, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-ModalSubtitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: {
            text: {
              value: modalSubTitle
            }
          },
          "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
        })
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(ContactFormFields, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-ContactFormFields",
        children: fields.map(([fieldKey, field]) => {
          const value = formData[fieldKey] ?? "";
          const error = errors[fieldKey];
          const inputType = field.type === "EMAIL" ? "email" : field.type === "TEL" ? "tel" : "text";
          return /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
            flex: "1",
            labelTxt: field.label,
            placeholderTxt: field.placeholder,
            requiredField: field.isRequired,
            inputValue: value,
            errorState: error,
            hasError: !!error,
            showError: !!error,
            isDisabled: !field.isEnabled,
            inputType: inputType,
            handleChange: e => handleFieldChange(fieldKey, e.target.value),
            handleFocus: field.isMasked ? () => handleMaskedFocus(fieldKey) : undefined,
            handleBlur: e => {
              if (field.isMasked) {
                handleMaskedBlur(fieldKey, e.target.value, field);
              } else {
                const err = validateField(e.target.value, field);
                setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
                  [fieldKey]: err
                }));
              }
            },
            margin: "0",
            "data-test-id": `AddAlternateContactModal-renderFormContent-FormInput-${fieldKey}`
          }, fieldKey);
        })
      })]
    }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalFooter, {
      "data-test-id": "AddAlternateContactModal-renderFormContent-ModalFooter",
      children: [apiErrorMessage && /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* StickyErrorBanner */.sD, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorBanner",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorIcon */.wL, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: constants/* ORDER_DETAIL_V2_ASSETS.VALIDATION_ERROR_ICON */.XK.VALIDATION_ERROR_ICON,
            width: "24",
            height: "24",
            alt: "Error",
            "data-test-id": "AddAlternateContactModal-renderFormContent-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorText */.m5, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              html: apiErrorMessage
            },
            "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterButtonRow, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-FooterButtonRow",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterLeft, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-FooterLeft",
          children: backCta?.isVisible !== false && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
            btnTxt: backLabel,
            showDefaultRightIcon: false,
            onClick: handleClose,
            disabled: isLoading,
            "data-test-id": "AddAlternateContactModal-renderFormContent-TextButton"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterRight, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-FooterRight",
          children: saveCta?.isVisible !== false && /*#__PURE__*/(0,jsx_runtime.jsx)(SaveButton, {
            type: "button",
            onClick: handleSave,
            hasChanges: canSave,
            isLoading: isLoading,
            disabled: !canSave || isLoading,
            "data-test-id": "AddAlternateContactModal-renderFormContent-SaveButton",
            children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.Spinner, {
                spinnerWidth: 16,
                spinnerColor: Global/* theme.whiteText */.rS.whiteText,
                thickness: 2,
                "data-test-id": "AddAlternateContactModal-renderFormContent-Spinner"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: {
                  text: {
                    value: saveLabel
                  }
                },
                "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: {
                text: {
                  value: saveLabel
                }
              },
              "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
            })
          })
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [apiErrorMessage && /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* StickyErrorBanner */.sD, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorBanner",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorIcon */.wL, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: constants/* ORDER_DETAIL_V2_ASSETS.VALIDATION_ERROR_ICON */.XK.VALIDATION_ERROR_ICON,
            width: "24",
            height: "24",
            alt: "Error",
            "data-test-id": "AddAlternateContactModal-renderFormContent-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* StickyErrorText */.m5, {
          "data-test-id": "AddAlternateContactModal-renderFormContent-StickyErrorText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              html: apiErrorMessage
            },
            "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SheetFooter */.FF, {
        "data-test-id": "AddAlternateContactModal-renderFormContent-SheetFooter",
        children: saveCta?.isVisible !== false && /*#__PURE__*/(0,jsx_runtime.jsx)(SaveButton, {
          type: "button",
          onClick: handleSave,
          hasChanges: canSave,
          isLoading: isLoading,
          disabled: !canSave || isLoading,
          "data-test-id": "AddAlternateContactModal-renderFormContent-SaveButton",
          children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.Spinner, {
              spinnerWidth: 16,
              spinnerColor: "#ffffff",
              thickness: 2,
              "data-test-id": "AddAlternateContactModal-renderFormContent-Spinner"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: {
                text: {
                  value: saveLabel
                }
              },
              "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              text: {
                value: saveLabel
              }
            },
            "data-test-id": "AddAlternateContactModal-renderFormContent-FormattedText"
          })
        })
      })]
    })]
  }); // Mobile: Render as full-page sheet


  if (device === "sm") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components.ReactPortalComp, {
      "data-test-id": "AddAlternateContactModal-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal_style/* EditTravellersSheetStyle */.i9, {
        "data-test-id": "AddAlternateContactModal-EditTravellersSheetStyle",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingHeaderMobile, {
          displayWhiteHeader: true,
          headerTitle: isResultView ? "" : modalTitle,
          handleBackBtn: handleClose,
          "data-test-id": "AddAlternateContactModal-LandingHeaderMobile"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal_style/* SheetContent */.ue, {
          "data-test-id": "AddAlternateContactModal-SheetContent",
          children: isResultView ? renderResultView() : renderFormContent()
        })]
      })
    });
  } // Desktop: Render as modal


  return /*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalDweb/* default */.Z, {
    customTitle: isResultView ? "" : modalTitle,
    handleClick: handleClose,
    customWidth: isResultView ? "420px" : "480px",
    nonClipHeading: true,
    "data-test-id": "AddAlternateContactModal-CommonModalDweb",
    children: isResultView ? renderResultView() : renderFormContent()
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddAlternateContactModal/index.ts

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Contact/OrderDetailV2Contact.tsx












const getTextValue = node => {
  if (!node) return "";
  if (typeof node === "string") return node;
  const {
    text
  } = node;
  if (!text) return "";
  if (typeof text === "string") return text;
  if (Array.isArray(text)) return text.map(t => t.value ?? "").join("");
  return text.value ?? "";
};

const OrderDetailV2Contact = ({
  sectionTitle,
  sectionIcon,
  mailIcon,
  callIcon,
  primarySection,
  alternateSection,
  formConfig,
  modalConfig,
  primaryEntity = null
}) => {
  const {
    bookingId,
    refreshOrderDetails
  } = (0,OrderDetailV2Context/* useOrderDetailV2 */.g)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isAlternateContactModalOpen,
    1: setIsAlternateContactModalOpen
  } = (0,react.useState)(false);
  const alternateContact = alternateSection?.contact;
  const hasAlternateContact = Boolean(alternateContact?.emailNode || alternateContact?.contactNoNode);
  const isAlternateSectionVisible = alternateSection?.isVisible ?? false;
  const alternateAction = alternateSection?.action;
  const isActionEnabled = alternateAction?.isEnabled ?? false;
  const isActionVisible = alternateAction?.isVisible ?? false;
  const initialAlternateValues = hasAlternateContact ? {
    name: getTextValue(alternateContact?.nameNode),
    email: getTextValue(alternateContact?.emailNode),
    phone: getTextValue(alternateContact?.contactNoNode)
  } : undefined;

  const handleSaveAlternateContact = () => {};

  const openAlternateContactModal = () => {
    if (isActionEnabled && formConfig) {
      setIsAlternateContactModalOpen(true);
    }
  };

  if (!primarySection) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* Card */.Zb, {
    "data-test-id": "OrderDetailV2Contact-Card",
    children: [device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* CardPadding */.fW, {
      "data-test-id": "OrderDetailV2Contact-CardPadding",
      children: [sectionTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactHeader */.W7, {
        "data-test-id": "OrderDetailV2Contact-ContactHeader",
        children: [sectionIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          src: sectionIcon,
          width: "20px",
          height: "20px",
          margin: "0 8px 0 0",
          "data-test-id": "OrderDetailV2Contact-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "large",
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "OrderDetailV2Contact-SpanTag",
          children: sectionTitle
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactGrid */.HN, {
        "data-test-id": "OrderDetailV2Contact-ContactGrid",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactBox */.Cv, {
          "data-test-id": "OrderDetailV2Contact-ContactBox",
          children: [primarySection.title && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactBoxHeader */.u5, {
            "data-test-id": "OrderDetailV2Contact-ContactBoxHeader",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: primarySection.title
            }), primarySection.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: primarySection.icon,
              width: "20px",
              height: "20px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "OrderDetailV2Contact-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: primarySection.contact.nameNode,
              "data-test-id": "OrderDetailV2Contact-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
            "data-test-id": "OrderDetailV2Contact-ContactLine",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: mailIcon,
              width: "16px",
              height: "16px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: primarySection.contact.emailNode,
                "data-test-id": "OrderDetailV2Contact-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
            "data-test-id": "OrderDetailV2Contact-ContactLine",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: callIcon,
              width: "16px",
              height: "16px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: primarySection.contact.contactNoNode,
                "data-test-id": "OrderDetailV2Contact-FormattedText"
              })
            })]
          })]
        }), isAlternateSectionVisible && alternateSection && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactBox */.Cv, {
          "data-test-id": "OrderDetailV2Contact-ContactBox",
          children: [alternateSection.title && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactBoxHeader */.u5, {
            "data-test-id": "OrderDetailV2Contact-ContactBoxHeader",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: alternateSection.title
            }), alternateSection.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: alternateSection.icon,
              width: "20px",
              height: "20px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            }), isActionVisible && alternateAction?.label && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
              btnTxt: alternateAction.label,
              onClick: openAlternateContactModal,
              disabled: !isActionEnabled,
              showDefaultRightIcon: false,
              "data-test-id": "OrderDetailV2Contact-TextButton"
            })]
          }), hasAlternateContact ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [alternateContact?.emailNode && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
              "data-test-id": "OrderDetailV2Contact-ContactLine",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                src: mailIcon,
                width: "16px",
                height: "16px",
                "data-test-id": "OrderDetailV2Contact-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "OrderDetailV2Contact-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: alternateContact.emailNode,
                  "data-test-id": "OrderDetailV2Contact-FormattedText"
                })
              })]
            }), alternateContact?.contactNoNode && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
              "data-test-id": "OrderDetailV2Contact-ContactLine",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                src: callIcon,
                width: "16px",
                height: "16px",
                "data-test-id": "OrderDetailV2Contact-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "OrderDetailV2Contact-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: alternateContact.contactNoNode,
                  "data-test-id": "OrderDetailV2Contact-FormattedText"
                })
              })]
            })]
          }) : alternateSection.hint && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "xs",
            color: Global/* theme.greyText7 */.rS.greyText7,
            "data-test-id": "OrderDetailV2Contact-SpanTag",
            children: alternateSection.hint
          })]
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [primarySection.title && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactMobileSection */.jw, {
        zIndex: 3,
        "data-test-id": "OrderDetailV2Contact-ContactMobileSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ContactMobileSectionHeader */.Nt, {
          "data-test-id": "OrderDetailV2Contact-ContactMobileSectionHeader",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ContactMobileTitle */.d5, {
            "data-test-id": "OrderDetailV2Contact-ContactMobileTitle",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: primarySection.title,
              "data-test-id": "OrderDetailV2Contact-FormattedText"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactMobileContent */.wA, {
          "data-test-id": "OrderDetailV2Contact-ContactMobileContent",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "OrderDetailV2Contact-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: primarySection.contact.nameNode,
              "data-test-id": "OrderDetailV2Contact-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
            "data-test-id": "OrderDetailV2Contact-ContactLine",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: mailIcon,
              width: "16px",
              height: "16px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: primarySection.contact.emailNode,
                "data-test-id": "OrderDetailV2Contact-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
            "data-test-id": "OrderDetailV2Contact-ContactLine",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: callIcon,
              width: "16px",
              height: "16px",
              "data-test-id": "OrderDetailV2Contact-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: primarySection.contact.contactNoNode,
                "data-test-id": "OrderDetailV2Contact-FormattedText"
              })
            })]
          })]
        })]
      }), isAlternateSectionVisible && alternateSection && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [alternateSection.title && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactMobileSection */.jw, {
          zIndex: 2,
          "data-test-id": "OrderDetailV2Contact-ContactMobileSection",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ContactMobileSectionHeader */.Nt, {
            "data-test-id": "OrderDetailV2Contact-ContactMobileSectionHeader",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ContactMobileTitle */.d5, {
              "data-test-id": "OrderDetailV2Contact-ContactMobileTitle",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: alternateSection.title,
                "data-test-id": "OrderDetailV2Contact-FormattedText"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ContactMobileContent */.wA, {
            "data-test-id": "OrderDetailV2Contact-ContactMobileContent",
            children: hasAlternateContact ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [alternateContact?.emailNode && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
                "data-test-id": "OrderDetailV2Contact-ContactLine",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  src: mailIcon,
                  width: "16px",
                  height: "16px",
                  "data-test-id": "OrderDetailV2Contact-ImageComponent"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderDetailV2Contact-SpanTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                    value: alternateContact.emailNode,
                    "data-test-id": "OrderDetailV2Contact-FormattedText"
                  })
                })]
              }), alternateContact?.contactNoNode && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* ContactLine */.mo, {
                "data-test-id": "OrderDetailV2Contact-ContactLine",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  src: callIcon,
                  width: "16px",
                  height: "16px",
                  "data-test-id": "OrderDetailV2Contact-ImageComponent"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderDetailV2Contact-SpanTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                    value: alternateContact.contactNoNode,
                    "data-test-id": "OrderDetailV2Contact-FormattedText"
                  })
                })]
              })]
            }) : alternateSection.hint && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "OrderDetailV2Contact-SpanTag",
              children: alternateSection.hint
            })
          })]
        }), isActionVisible && alternateAction?.label && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaDivider */.Bs, {
            "data-test-id": "OrderDetailV2Contact-CardCtaDivider"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaButtonList */.ci, {
            "data-test-id": "OrderDetailV2Contact-CardCtaButtonList",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
              btnTxt: alternateAction.label,
              onClick: openAlternateContactModal,
              disabled: !isActionEnabled,
              fullWidth: true,
              "data-test-id": "OrderDetailV2Contact-TextButton"
            })
          })]
        })]
      })]
    }), formConfig && bookingId && primaryEntity && /*#__PURE__*/(0,jsx_runtime.jsx)(AddAlternateContactModal, {
      isOpen: isAlternateContactModalOpen,
      onClose: () => setIsAlternateContactModalOpen(false),
      formConfig: formConfig,
      modalConfig: modalConfig ?? undefined,
      initialValues: initialAlternateValues,
      bookingId: bookingId,
      primaryEntity: primaryEntity,
      onSave: handleSaveAlternateContact,
      onEndorsementSuccess: refreshOrderDetails,
      "data-test-id": "OrderDetailV2Contact-AddAlternateContactModal"
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Contact/index.ts


/***/ }),

/***/ 32402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* reexport */ OrderDetailV2ForInsurance)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderDetailRightComp.style.ts
var OrderDetailRightComp_style = __webpack_require__(61874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/hooks/useOrderActions.ts
var useOrderActions = __webpack_require__(25109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ForInsurance/OrderDetailV2ForInsurance.style.ts



const ItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2ForInsurancestyle__ItemsContainer",
  componentId: "sc-19zetzh-0"
})(["display:flex;flex-direction:column;gap:15px;@media ", "{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;}"], utils/* deviceType.mobile */.vO.mobile);
const ItemButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "OrderDetailV2ForInsurancestyle__ItemButton",
  componentId: "sc-19zetzh-1"
})(["display:flex;align-items:center;gap:16px;background:transparent;border:none;padding:0;cursor:", ";opacity:", ";pointer-events:", ";width:100%;text-align:left;font-family:Lato;font-weight:700;font-size:14px;line-height:100%;letter-spacing:0;color:", ";img,svg{width:100%;height:100%;display:block;", "}@media ", "{height:32px;align-items:center;justify-content:center;padding:12px 16px;border-radius:8px;background:", ";border:", ";gap:4px;font-weight:900;font-size:12px;text-align:center;color:", ";}&:focus{outline:none;}&:focus-visible{outline:2px solid ", ";outline-offset:2px;}"], props => props.isDisabled ? "default" : "pointer", props => props.isDisabled ? 0.45 : 1, props => props.isDisabled ? "none" : "auto", props => props.isDisabled ? Global/* theme.greyText4 */.rS.greyText4 : Global/* theme.blueText */.rS.blueText, props => props.disabled && `
      filter: grayscale(100%);
      opacity: 0.90;
    `, utils/* deviceType.mobile */.vO.mobile, props => props.isDisabled ? Global/* theme.greyText2 */.rS.greyText2 : Global/* theme.whiteText */.rS.whiteText, props => props.isDisabled ? "none" : `1px solid ${Global/* theme.blueText */.rS.blueText}`, props => props.isDisabled ? Global/* theme.lightBlack */.rS.lightBlack : Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText);
const ButtonIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2ForInsurancestyle__ButtonIcon",
  componentId: "sc-19zetzh-2"
})(["width:20px;height:20px;flex-shrink:0;display:flex;align-items:center;justify-content:center;img,svg{width:100%;height:100%;display:block;", "}"], props => props.isDisabled && `
      filter: grayscale(100%);
      opacity: 0.90;
    `);
const ButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "OrderDetailV2ForInsurancestyle__ButtonText",
  componentId: "sc-19zetzh-3"
})(["font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;white-space:nowrap;@media ", "{white-space:nowrap;}"], utils/* deviceType.mobile */.vO.mobile);
const ContentWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
  "data-insurance-content": true
}).withConfig({
  displayName: "OrderDetailV2ForInsurancestyle__ContentWrapper",
  componentId: "sc-19zetzh-4"
})(["padding:20px;@media ", "{padding:16px;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ForInsurance/OrderDetailV2ForInsurance.tsx









const OrderDetailV2ForInsurance = ({
  title,
  items,
  actionsConfig
}) => {
  const {
    executeAction
  } = (0,useOrderActions/* useOrderActions */.B)(actionsConfig);

  if ((0,lodash.isEmpty)(items)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* Card */.Zb, {
    "data-test-id": "OrderDetailV2ForInsurance-Card",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailRightComp_style/* OrderRightHd */.M9, {
      "data-test-id": "OrderDetailV2ForInsurance-OrderRightHd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderDetailV2ForInsurance-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: title,
          "data-test-id": "OrderDetailV2ForInsurance-FormattedText"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardPadding */.fW, {
      "data-test-id": "OrderDetailV2ForInsurance-CardPadding",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemsContainer, {
        "data-test-id": "OrderDetailV2ForInsurance-ItemsContainer",
        children: items.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemButton, {
          isDisabled: item.isDisabled,
          onClick: () => executeAction(item.sectionType),
          disabled: item.isDisabled,
          "aria-label": item.title,
          "data-test-id": "OrderDetailV2ForInsurance-ItemButton",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonIcon, {
            isDisabled: item.isDisabled,
            "data-test-id": "OrderDetailV2ForInsurance-ButtonIcon",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "20px",
              height: "20px",
              src: item.icon,
              "data-test-id": "OrderDetailV2ForInsurance-ImageComponent"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonText, {
            "data-test-id": "OrderDetailV2ForInsurance-ButtonText",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.title,
              "data-test-id": "OrderDetailV2ForInsurance-FormattedText"
            })
          })]
        }, `${item.sectionType}-${index}`))
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2ForInsurance/index.ts


/***/ }),

/***/ 34028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": () => (/* reexport */ OrderDetailV2Hero),
  "M": () => (/* reexport */ OrderDetailV2HeroPWA)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Hero/OrderDetailV2Hero.tsx







const OrderDetailV2Hero = ({
  bookingId,
  title,
  orderIdLabel,
  icon,
  bgColor,
  showNav
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* Hero */.VM, {
    bgColor: bgColor,
    "data-test-id": "OrderDetailV2Hero-Hero",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* Container */.W2, {
      "data-test-id": "OrderDetailV2Hero-Container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* HeroHeader */.vx, {
        "data-test-id": "OrderDetailV2Hero-HeroHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* HeroTitleWrap */.Uo, {
          "data-test-id": "OrderDetailV2Hero-HeroTitleWrap",
          children: [showNav && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* BreadcrumbBar */.Sg, {
            "data-test-id": "OrderDetailV2Hero-BreadcrumbBar",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* BreadcrumbText */.bY, {
              as: "a",
              href: constants/* ORDER_DETAIL_V2_URLS.MY_TRIPS */.Mr.MY_TRIPS,
              style: {
                textDecoration: "none",
                cursor: "pointer"
              },
              "data-test-id": "OrderDetailV2Hero-BreadcrumbText",
              children: "My Trips"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* BreadcrumbSep */.Ar, {
              "data-test-id": "OrderDetailV2Hero-BreadcrumbSep",
              children: ">"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* BreadcrumbText */.bY, {
              "data-test-id": "OrderDetailV2Hero-BreadcrumbText",
              children: "Insurance"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* HeroTitle */.LR, {
            "data-test-id": "OrderDetailV2Hero-HeroTitle",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xlarge",
              fontWeight: "black",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "OrderDetailV2Hero-SpanTag",
              children: title || "Your Trip Is Secured!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "OrderDetailV2Hero-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* FormattedTextWrapper */.IZ, {
                "data-test-id": "OrderDetailV2Hero-FormattedTextWrapper",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: {
                    html: orderIdLabel
                  },
                  baseStyle: {},
                  "data-test-id": "OrderDetailV2Hero-FormattedText"
                })
              })
            })]
          })]
        }), icon && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* HeroImageWrapper */.Su, {
          "data-test-id": "OrderDetailV2Hero-HeroImageWrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: icon,
            width: "440px",
            height: "160px",
            "data-test-id": "OrderDetailV2Hero-ImageComponent"
          })
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/backArrow.svg
var backArrow = __webpack_require__(77968);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Hero/OrderDetailV2HeroPWA.tsx








const OrderDetailV2HeroPWA = ({
  title
}) => {
  const router = (0,next_router.useRouter)();

  const handleBackClick = () => {
    if (window.mmt_android_bridge) {
      window.mmt_android_bridge.closeWebView();
    } else {
      router.back();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* HeroTopSection */.HE, {
      "data-test-id": "OrderDetailV2HeroPWA-HeroTopSection",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* BackArrowButton */.XE, {
        type: "button",
        onClick: handleBackClick,
        "data-test-id": "OrderDetailV2HeroPWA-BackArrowButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          src: backArrow/* default.src */.Z.src,
          width: "24px",
          height: "24px",
          "data-test-id": "OrderDetailV2HeroPWA-ImageComponent"
        })
      })
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* HeroTitleSectionPWA */.l0, {
      "data-test-id": "OrderDetailV2HeroPWA-HeroTitleSectionPWA",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* HeroTitlePWA */.yA, {
        "data-test-id": "OrderDetailV2HeroPWA-HeroTitlePWA",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: title,
          "data-test-id": "OrderDetailV2HeroPWA-FormattedText"
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Hero/index.ts



/***/ }),

/***/ 81312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* reexport */ OrderDetailV2Nominee)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Context.tsx
var OrderDetailV2Context = __webpack_require__(23027);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts + 1 modules
var constants = __webpack_require__(23087);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/index.ts + 1 modules
var EditTravellersModal = __webpack_require__(40648);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/index.ts + 10 modules
var FormRenderer = __webpack_require__(42105);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/FormRenderer/formUtils.ts
var formUtils = __webpack_require__(23567);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/InfoModalContent/index.ts + 1 modules
var InfoModalContent = __webpack_require__(7125);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddNomineeModal/AddNomineeModal.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











 // ── Entity data extractor for nominee form ─────────────────────────────





const extractNomineeData = entity => {
  const nomineeDetails = Array.isArray(entity.data?.["nomineeDetails"]) ? entity.data["nomineeDetails"] : [];
  return nomineeDetails.length > 0 ? nomineeDetails[0] : {};
}; // ── Build endorsement payload ──────────────────────────────────────────


const buildEndorsementPayload = (entities, formData, expandedTravellers, formConfig) => {
  const updatedEntities = entities.map((entity, index) => {
    const nomineeData = formData[index];
    const isExpanded = expandedTravellers[index];

    if (!isExpanded) {
      return _objectSpread(_objectSpread({}, entity), {}, {
        data: _objectSpread(_objectSpread({}, entity.data), {}, {
          nomineeDetails: []
        })
      });
    }

    const updatedData = _objectSpread({}, entity.data);

    const nominee = {};
    formConfig.fields.forEach(field => {
      let value = String(nomineeData[field.name] || "");

      if (field.type === "DATE" && value) {
        value = (0,formUtils/* convertYYYYMMDDToDDMMYYYY */.ej)(value);
      }

      nominee[field.name] = value;
    });
    formConfig.dynamicFields?.forEach(df => {
      const dynamicData = nomineeData.dynamicFields?.[df.triggerId];

      if (dynamicData?.visible) {
        df.fields.forEach(field => {
          nominee[field.name] = String(dynamicData[field.name] || "");
        });
      }
    });
    updatedData["nomineeDetails"] = [nominee];
    return _objectSpread(_objectSpread({}, entity), {}, {
      data: updatedData
    });
  });
  const payload = updatedEntities.map(e => _objectSpread({
    entityId: e.id
  }, e.data));
  return {
    payload,
    updatedEntities
  };
}; // ── Component ──────────────────────────────────────────────────────────


const AddNomineeModal = ({
  isOpen,
  onClose,
  formConfig: rawFormConfig,
  entities,
  bookingId,
  onSave,
  onEndorsementSuccess,
  modalTitle = "Add Nominees",
  saveButtonLabel = "SAVE DETAILS"
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const formConfig = (0,react.useMemo)(() => (0,formUtils/* normalizeFormConfig */.A$)(rawFormConfig), [rawFormConfig]); // ── Shared form state ────────────────────────────────────────────────

  const {
    formData,
    setFormData,
    errors,
    setErrors,
    initialDataRef,
    getFieldRef,
    handleMaskedFocus,
    handleMaskedBlur,
    handleFieldChange,
    handleDynamicFieldChange,
    toggleDynamicField,
    validateAllFields,
    hasFormDataChanged: formDataChanged
  } = (0,FormRenderer/* useFormRenderer */.OS)({
    isOpen,
    formConfig,
    entities,
    extractEntityData: extractNomineeData
  }); // ── Expansion / endorsement state (nominee-specific) ─────────────────

  const {
    0: expandedTravellers,
    1: setExpandedTravellers
  } = (0,react.useState)({});
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: endorsementView,
    1: setEndorsementView
  } = (0,react.useState)("form");
  const {
    0: endorsementData,
    1: setEndorsementData
  } = (0,react.useState)(null);
  const {
    0: apiErrorMessage,
    1: setApiErrorMessage
  } = (0,react.useState)(null);
  const pendingRefreshRef = (0,react.useRef)(false);
  const prevIsOpenRef = (0,react.useRef)(false); // Initialize expansion state when modal opens

  react.useEffect(() => {
    if (isOpen && entities.length > 0) {
      const isJustOpened = !prevIsOpenRef.current;
      prevIsOpenRef.current = true;
      const expansion = {};
      entities.forEach((entity, idx) => {
        const nomineeDetails = Array.isArray(entity.data?.["nomineeDetails"]) ? entity.data["nomineeDetails"] : [];
        expansion[idx] = nomineeDetails.length > 0;
      });
      setExpandedTravellers(expansion);

      if (isJustOpened) {
        setEndorsementView("form");
        setEndorsementData(null);
        setApiErrorMessage(null);
        setIsLoading(false);
      }
    } else if (!isOpen) {
      prevIsOpenRef.current = false;
    }
  }, [isOpen, entities]); // ── Clear API error on field edit ──────────────────────────────────────

  const wrappedHandleFieldChange = (entityIndex, fieldKey, value) => {
    if (apiErrorMessage) setApiErrorMessage(null);
    handleFieldChange(entityIndex, fieldKey, value);
  };

  const wrappedHandleDynamicFieldChange = (entityIndex, triggerId, fieldKey, value) => {
    if (apiErrorMessage) setApiErrorMessage(null);
    handleDynamicFieldChange(entityIndex, triggerId, fieldKey, value);
  }; // ── Nominee-specific helpers ─────────────────────────────────────────


  const toggleTravellerExpansion = idx => {
    setExpandedTravellers(p => _objectSpread(_objectSpread({}, p), {}, {
      [idx]: !p[idx]
    }));
  };

  const removeNominee = idx => {
    const updated = [...formData];
    updated[idx] = {};
    formConfig.fields.forEach(f => {
      updated[idx][f.name] = "";
    });
    updated[idx].dynamicFields = {};
    setFormData(updated);
    setExpandedTravellers(p => _objectSpread(_objectSpread({}, p), {}, {
      [idx]: false
    }));
    setErrors(p => {
      const u = _objectSpread({}, p);

      delete u[idx];
      return u;
    });
  };

  const hadNomineeInitially = idx => {
    const initial = initialDataRef.current[idx];
    if (!initial) return false;

    for (const f of formConfig.fields) {
      if (String(initial[f.name] || "").trim()) return true;
    }

    if (formConfig.dynamicFields) {
      for (const df of formConfig.dynamicFields) {
        const d = initial.dynamicFields?.[df.triggerId];

        if (d?.visible) {
          for (const f of df.fields) {
            if (String(d[f.name] || "").trim()) return true;
          }
        }
      }
    }

    return false;
  };

  const hasFormDataChanged = () => {
    for (let i = 0; i < entities.length; i++) {
      if (!expandedTravellers[i] && hadNomineeInitially(i)) return true;
    }

    return formDataChanged(idx => !!expandedTravellers[idx]);
  }; // ── Save / Close ─────────────────────────────────────────────────────


  const handleSave = async () => {
    if (!validateAllFields(idx => !!expandedTravellers[idx])) return;
    setIsLoading(true);

    try {
      const {
        payload,
        updatedEntities
      } = buildEndorsementPayload(entities, formData, expandedTravellers, formConfig);
      const res = await (0,api/* submitEndorsement */.Yh)({
        bookingId,
        payload
      });
      setEndorsementData(res);
      const status = (res?.status ?? "").toUpperCase();

      if (status === "SUCCESS") {
        setEndorsementView("success");
        setApiErrorMessage(null);
        initialDataRef.current = JSON.parse(JSON.stringify(formData));
        await Promise.resolve(onSave(updatedEntities));
        pendingRefreshRef.current = true;
      } else if (status === "ERROR" || status === "VALIDATION_ERROR") {
        setApiErrorMessage(res?.desc || res?.subtitle || res?.title || "An error occurred. Please try again.");
        setEndorsementView("form");
      } else {
        setEndorsementView("generating");
      }
    } catch {
      setApiErrorMessage("An error occurred. Please try again.");
      setEndorsementView("form");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (pendingRefreshRef.current) {
      pendingRefreshRef.current = false;
      onEndorsementSuccess?.();
    }

    onClose();
  }; // ── Render ───────────────────────────────────────────────────────────


  if (!isOpen) return null;
  const isResultView = endorsementView === "success" || endorsementView === "generating";
  const formChanged = hasFormDataChanged();
  const removeNomineeLabel = formConfig?.commonActions?.removeNominee?.label || "Remove Nominee";

  const renderSaveButton = () => /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* SaveButton */.k$, {
    onClick: handleSave,
    hasChanges: formChanged,
    isLoading: isLoading,
    disabled: !formChanged || isLoading,
    "data-test-id": "AddNomineeModal-renderSaveButton-SaveButton",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.Spinner, {
        spinnerWidth: 16,
        spinnerColor: Global/* theme.whiteText */.rS.whiteText,
        thickness: 2,
        "data-test-id": "AddNomineeModal-renderSaveButton-Spinner"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: saveButtonLabel,
        "data-test-id": "AddNomineeModal-renderSaveButton-FormattedText"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
      value: saveButtonLabel,
      "data-test-id": "AddNomineeModal-renderSaveButton-FormattedText"
    })
  });

  const renderFormContent = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* TravellerFormSection */.Xd, {
      "data-test-id": "AddNomineeModal-renderFormContent-TravellerFormSection",
      children: entities.map((entity, travellerIndex) => {
        const travellerName = entity.data?.["name"] || `Traveller ${travellerIndex + 1}`;
        const isExpanded = expandedTravellers[travellerIndex] ?? false;
        const nomineeData = formData[travellerIndex] || {};

        if (!isExpanded) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer/* FormCard */.Ec, {
            "data-test-id": `AddNomineeModal-renderFormContent-FormCard-${travellerIndex}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              alignItems: "center",
              justifyContent: "space-between",
              margin: "0",
              "data-test-id": "AddNomineeModal-renderFormContent-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "md",
                fontWeight: "bold",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "AddNomineeModal-renderFormContent-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: travellerName,
                  "data-test-id": "AddNomineeModal-renderFormContent-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* AddButton */.HS, {
                onClick: () => toggleTravellerExpansion(travellerIndex),
                "data-test-id": "AddNomineeModal-renderFormContent-AddButton",
                children: "ADD"
              })]
            })
          }, travellerIndex);
        }

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormRenderer/* FormCard */.Ec, {
          "data-test-id": `AddNomineeModal-renderFormContent-FormCard-${travellerIndex}`,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            margin: "0 0 16px",
            "data-test-id": "AddNomineeModal-renderFormContent-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "md",
              fontWeight: "bold",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "AddNomineeModal-renderFormContent-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: travellerName,
                "data-test-id": "AddNomineeModal-renderFormContent-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
              fontWeight: "bold",
              handleClick: () => removeNominee(travellerIndex),
              "data-test-id": "AddNomineeModal-renderFormContent-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: removeNomineeLabel,
                "data-test-id": "AddNomineeModal-renderFormContent-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormRenderer/* FormRendererFields */.vo, {
            entityIndex: travellerIndex,
            entityData: nomineeData,
            entityErrors: errors[travellerIndex] || {},
            formConfig: formConfig,
            getFieldRef: getFieldRef,
            handleFieldChange: wrappedHandleFieldChange,
            handleMaskedFocus: handleMaskedFocus,
            handleMaskedBlur: handleMaskedBlur,
            handleDynamicFieldChange: wrappedHandleDynamicFieldChange,
            toggleDynamicField: toggleDynamicField,
            setErrors: setErrors,
            "data-test-id": "AddNomineeModal-renderFormContent-FormRendererFields"
          })]
        }, travellerIndex);
      })
    }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal/* ModalFooter */.mz, {
      "data-test-id": "AddNomineeModal-renderFormContent-ModalFooter",
      children: [apiErrorMessage && /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal/* StickyErrorBanner */.sD, {
        "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorBanner",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* StickyErrorIcon */.wL, {
          "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: constants/* ORDER_DETAIL_V2_ASSETS.VALIDATION_ERROR_ICON */.XK.VALIDATION_ERROR_ICON,
            width: "24",
            height: "24",
            alt: "Error",
            "data-test-id": "AddNomineeModal-renderFormContent-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* StickyErrorText */.m5, {
          "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              html: apiErrorMessage
            },
            "data-test-id": "AddNomineeModal-renderFormContent-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* ModalFooterActions */.vD, {
        "data-test-id": "AddNomineeModal-renderFormContent-ModalFooterActions",
        children: renderSaveButton()
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [apiErrorMessage && /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal/* StickyErrorBanner */.sD, {
        "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorBanner",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* StickyErrorIcon */.wL, {
          "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            src: constants/* ORDER_DETAIL_V2_ASSETS.VALIDATION_ERROR_ICON */.XK.VALIDATION_ERROR_ICON,
            width: "24",
            height: "24",
            alt: "Error",
            "data-test-id": "AddNomineeModal-renderFormContent-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* StickyErrorText */.m5, {
          "data-test-id": "AddNomineeModal-renderFormContent-StickyErrorText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: {
              html: apiErrorMessage
            },
            "data-test-id": "AddNomineeModal-renderFormContent-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* SheetFooter */.FF, {
        "data-test-id": "AddNomineeModal-renderFormContent-SheetFooter",
        children: renderSaveButton()
      })]
    })]
  });

  const renderResultView = () => /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* SubmitModalWrapper */.SA, {
    "data-test-id": "AddNomineeModal-renderResultView-SubmitModalWrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoModalContent/* InfoModalContent */.T, {
      viewType: endorsementView,
      data: endorsementData,
      renderAction: data => {
        if (endorsementView === "success" && data.cta?.isEnabled !== false && data.cta?.label && data.newPolicyUrl) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* SaveButton */.k$, {
            as: "a",
            href: data.newPolicyUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            hasChanges: true,
            isLoading: false,
            style: {
              marginTop: "16px",
              textDecoration: "none"
            },
            "data-test-id": "AddNomineeModal-renderResultView-SaveButton",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: data.cta.label,
              "data-test-id": "AddNomineeModal-renderResultView-FormattedText"
            })
          });
        }

        return null;
      },
      "data-test-id": "AddNomineeModal-renderResultView-InfoModalContent"
    })
  }); // Mobile: full-page sheet


  if (device === "sm") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components.ReactPortalComp, {
      "data-test-id": "AddNomineeModal-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravellersModal/* EditTravellersSheetStyle */.i9, {
        "data-test-id": "AddNomineeModal-EditTravellersSheetStyle",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingHeaderMobile, {
          displayWhiteHeader: true,
          headerTitle: isResultView ? "" : modalTitle,
          handleBackBtn: handleClose,
          "data-test-id": "AddNomineeModal-LandingHeaderMobile"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* SheetContent */.ue, {
          "data-test-id": "AddNomineeModal-SheetContent",
          children: isResultView ? renderResultView() : renderFormContent()
        })]
      })
    });
  } // Desktop: modal


  return /*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalDweb/* default */.Z, {
    customTitle: isResultView ? "" : modalTitle,
    handleClick: handleClose,
    customWidth: isResultView ? "420px" : "720px",
    customHeight: isResultView ? "auto" : "640px",
    "data-test-id": "AddNomineeModal-CommonModalDweb",
    children: isResultView ? renderResultView() : renderFormContent()
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/AddNomineeModal/index.ts

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Tooltip/index.ts + 1 modules
var OrderDetailV2Tooltip = __webpack_require__(89159);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/index.ts + 2 modules
var TextButton = __webpack_require__(60313);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Nominee/OrderDetailV2Nominee.tsx












const OrderDetailV2Nominee = ({
  icon,
  title,
  actionLabel,
  isActionDisabled,
  actionDisabledReason,
  isActionVisible = true,
  persuasionText,
  nominees = [],
  formConfig,
  modalConfig,
  entities = [],
  actionList = []
}) => {
  const ctx = (0,OrderDetailV2Context/* useOrderDetailV2 */.g)();
  const disabled = Boolean(isActionDisabled);
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = (0,react.useState)(false);
  const device = (0,src/* useBreakpointV2 */.bU)();

  const openNomineeModal = () => {
    if (!disabled && formConfig) {
      setIsModalOpen(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* Card */.Zb, {
    "data-test-id": "OrderDetailV2Nominee-Card",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* CardPadding */.fW, {
      "data-test-id": "OrderDetailV2Nominee-CardPadding",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 0 10px",
        "data-test-id": "OrderDetailV2Nominee-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignItems: "center",
          gap: "8px",
          margin: "0",
          "data-test-id": "OrderDetailV2Nominee-FlexComp",
          children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* SectionHeaderIcon */.vN, {
            "data-test-id": "OrderDetailV2Nominee-SectionHeaderIcon",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: icon,
              width: "20px",
              height: "20px",
              "data-test-id": "OrderDetailV2Nominee-ImageComponent"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "large",
            fontWeight: "bold",
            color: device === "lg" ? Global/* theme.greyText */.rS.greyText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "OrderDetailV2Nominee-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: title || "Nominee Details (Optional)",
              "data-test-id": "OrderDetailV2Nominee-FormattedText"
            })
          })]
        }), device === "lg" && isActionVisible && actionLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2Tooltip/* OrderDetailV2Tooltip */.K, {
          message: actionDisabledReason || "",
          trigger: "both",
          show: disabled,
          position: "bottom",
          autoHideDelay: 5000,
          disabled: !disabled || !actionDisabledReason,
          "data-test-id": "OrderDetailV2Nominee-OrderDetailV2Tooltip",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
            btnTxt: actionLabel,
            onClick: openNomineeModal,
            disabled: disabled,
            showDefaultRightIcon: false,
            "data-test-id": "OrderDetailV2Nominee-TextButton"
          })
        })]
      }), persuasionText && device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* InfoStrip */.gp, {
        "data-test-id": "OrderDetailV2Nominee-InfoStrip",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "OrderDetailV2Nominee-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: persuasionText,
            "data-test-id": "OrderDetailV2Nominee-FormattedText"
          })
        })
      }) : null, nominees.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ListBox */.wb, {
        "data-test-id": "OrderDetailV2Nominee-ListBox",
        children: nominees.map((nominee, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ListRow */.wc, {
            "data-test-id": "OrderDetailV2Nominee-ListRow",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
              alignItems: "flex-start",
              justifyContent: "space-between",
              margin: "0",
              "data-test-id": "OrderDetailV2Nominee-FlexComp",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  minWidth: 0
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.ParaTag, {
                  fontSize: "md",
                  fontWeight: "bold",
                  "data-test-id": "OrderDetailV2Nominee-ParaTag",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                    value: nominee?.title || "Nominee",
                    "data-test-id": "OrderDetailV2Nominee-FormattedText"
                  }), nominee?.subTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [" - ", /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                      fontWeight: "regular",
                      fontSize: "md",
                      "data-test-id": "OrderDetailV2Nominee-SpanTag",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                        value: nominee.subTitle,
                        "data-test-id": "OrderDetailV2Nominee-FormattedText"
                      })
                    })]
                  })]
                }), nominee?.desc ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* RowMeta */.ri, {
                  "data-test-id": "OrderDetailV2Nominee-RowMeta",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                    fontSize: "xs",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "OrderDetailV2Nominee-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                      value: nominee.desc,
                      "data-test-id": "OrderDetailV2Nominee-FormattedText"
                    })
                  })
                }) : null]
              })
            })
          }, `${nominee?.entityId || "nominee"}-${index}`);
        })
      })]
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaDivider */.Bs, {
        "data-test-id": "OrderDetailV2Nominee-CardCtaDivider"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaButtonList */.ci, {
        "data-test-id": "OrderDetailV2Nominee-CardCtaButtonList",
        children: actionList.length > 0 ? actionList.map(action => /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
          fullWidth: true,
          btnTxt: action?.label || "",
          onClick: openNomineeModal,
          disabled: disabled,
          "data-test-id": "OrderDetailV2Nominee-TextButton"
        }, action?.id)) : actionLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
          fullWidth: true,
          btnTxt: actionLabel,
          onClick: openNomineeModal,
          disabled: disabled,
          "data-test-id": "OrderDetailV2Nominee-TextButton"
        })
      })]
    }), formConfig && ctx?.bookingId && /*#__PURE__*/(0,jsx_runtime.jsx)(AddNomineeModal, {
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false),
      formConfig: formConfig,
      entities: entities,
      bookingId: ctx.bookingId,
      onSave: () => {},
      onEndorsementSuccess: ctx.refreshOrderDetails,
      modalTitle: modalConfig?.header?.title || "Add Nominees",
      saveButtonLabel: modalConfig?.footer?.cta?.[0]?.label || "SAVE DETAILS",
      "data-test-id": "OrderDetailV2Nominee-AddNomineeModal"
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Nominee/index.ts


/***/ }),

/***/ 10975:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* reexport */ OrderDetailV2PaymentInfo)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderDetailRightComp.style.ts
var OrderDetailRightComp_style = __webpack_require__(61874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/utils/openDownloadUrl.ts
var openDownloadUrl = __webpack_require__(65492);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PaymentInfo/OrderDetailV2PaymentInfo.tsx








const PaymentHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PaymentInfo__PaymentHeader",
  componentId: "sc-5iqb59-0"
})(["padding:20px;background-color:", ";display:flex;justify-content:space-between;align-items:center;border-radius:15px 15px 0px 0px;gap:10px;"], Global/* theme.lightBlueBg */.rS.lightBlueBg);
const OutlineButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "OrderDetailV2PaymentInfo__OutlineButton",
  componentId: "sc-5iqb59-1"
})(["width:100%;padding:12px 20px;background:transparent;border:2px solid ", ";border-radius:8px;color:", ";font-weight:700;font-size:14px;text-transform:uppercase;cursor:", ";opacity:", ";pointer-events:", ";transition:all 0.2s ease-in-out;&:hover:not(:disabled){background-color:", ";color:", ";}&:focus{outline:none;box-shadow:0 0 0 2px rgba(0,140,255,0.3);}"], Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, props => props.disabled ? "not-allowed" : "pointer", props => props.disabled ? 0.45 : 1, props => props.disabled ? "none" : "auto", Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText);
const OrderDetailV2PaymentInfo = ({
  title,
  info,
  paymentBreakup,
  invoiceUrl,
  isActionDisabled,
  actionText
}) => {
  const handleDownloadInvoice = () => {
    if (isActionDisabled || !invoiceUrl) return;
    (0,openDownloadUrl/* openDownloadUrl */.Y)(invoiceUrl);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style/* OrderRightStyle */.oU, {
    "data-test-id": "OrderDetailV2PaymentInfo-OrderRightStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentHeader, {
      "data-test-id": "OrderDetailV2PaymentInfo-PaymentHeader",
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderDetailV2PaymentInfo-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: title,
          "data-test-id": "OrderDetailV2PaymentInfo-FormattedText"
        })
      }), info && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderDetailV2PaymentInfo-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: info,
          "data-test-id": "OrderDetailV2PaymentInfo-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style/* OrderRightCntnt */.X, {
      "data-test-id": "OrderDetailV2PaymentInfo-OrderRightCntnt",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          marginBottom: "8px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontWeight: "bold",
          fontSize: "xs",
          margin: "0",
          "data-test-id": "OrderDetailV2PaymentInfo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: "Payment Breakup",
            "data-test-id": "OrderDetailV2PaymentInfo-FormattedText"
          })
        })
      }), paymentBreakup.map((payment, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        justifyContent: "space-between",
        margin: "8px 0",
        "data-test-id": `OrderDetailV2PaymentInfo-FlexComp-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontSize: "xs",
          margin: "0",
          "data-test-id": "OrderDetailV2PaymentInfo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: payment.sourceText || "-",
            "data-test-id": "OrderDetailV2PaymentInfo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          "data-test-id": "OrderDetailV2PaymentInfo-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: payment.value || "-",
            "data-test-id": "OrderDetailV2PaymentInfo-FormattedText"
          })
        })]
      }, index)), /*#__PURE__*/(0,jsx_runtime.jsx)(OutlineButton, {
        disabled: isActionDisabled,
        onClick: handleDownloadInvoice,
        style: {
          marginTop: "16px"
        },
        "data-test-id": "OrderDetailV2PaymentInfo-OutlineButton",
        children: actionText
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PaymentInfo/index.ts


/***/ }),

/***/ 58962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* reexport */ OrderDetailV2PolicyDownload)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/DnldIcon.svg
var DnldIcon = __webpack_require__(34394);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PolicyDownload/OrderDetailV2PolicyDownload.tsx











const SectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PolicyDownload__SectionWrapper",
  componentId: "sc-2xotns-0"
})(["display:flex;flex-direction:column;width:100%;gap:16px;"]);
const DownloadButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PolicyDownload__DownloadButtonWrapper",
  componentId: "sc-2xotns-1"
})(["width:100%;@media ", "{margin-bottom:0;}"], utils/* deviceType.mobile */.vO.mobile);
const StatusCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PolicyDownload__StatusCardWrapper",
  componentId: "sc-2xotns-2"
})(["width:100%;"]);
const StatusIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "OrderDetailV2PolicyDownload__StatusIcon",
  componentId: "sc-2xotns-3"
})(["width:32px;height:32px;flex-shrink:0;align-self:center;"]);
const OrderDetailV2PolicyDownload = ({
  title,
  subTitle,
  desc,
  titleColor,
  subTitleColor,
  descColor,
  showSpinner,
  statusIcon,
  downloadAction,
  newPolicyUrl,
  showPolicyUpdateSection
}) => {
  const showDownloadButton = downloadAction?.isVisible === true;
  const device = (0,src/* useBreakpointV2 */.bU)();

  const handleDownload = () => {
    if (downloadAction?.isEnabled === false) return;

    if (newPolicyUrl) {
      const url = newPolicyUrl.startsWith("http") ? newPolicyUrl : `https://${newPolicyUrl}`;
      window.open(url, "_blank");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionWrapper, {
    "data-test-id": "OrderDetailV2PolicyDownload-SectionWrapper",
    children: [showDownloadButton && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadButtonWrapper, {
        "data-test-id": "OrderDetailV2PolicyDownload-DownloadButtonWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
          customTitle: downloadAction?.label ? String(downloadAction.label) : "DOWNLOAD POLICY",
          onClick: handleDownload,
          customWidth: "100%",
          customHeight: "44px",
          fontSize: "md",
          disableState: downloadAction?.isEnabled === false,
          btnLeftIcon: downloadAction?.icon ?? DnldIcon/* default.src */.Z.src,
          contentAlign: "left",
          "data-test-id": "OrderDetailV2PolicyDownload-LandingButton"
        })
      })
    }), showPolicyUpdateSection && /*#__PURE__*/(0,jsx_runtime.jsxs)(StatusCardWrapper, {
      "data-test-id": "OrderDetailV2PolicyDownload-StatusCardWrapper",
      children: [device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* Divider */.iz, {
        "data-test-id": "OrderDetailV2PolicyDownload-Divider"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* PolicyStatusCard */.kG, {
        "data-test-id": "OrderDetailV2PolicyDownload-PolicyStatusCard",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* PolicyStatusText */.js, {
          "data-test-id": "OrderDetailV2PolicyDownload-PolicyStatusText",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "md",
            color: titleColor || Global/* theme.greyText7 */.rS.greyText7,
            "data-test-id": "OrderDetailV2PolicyDownload-SpanTag",
            children: title
          }), subTitle ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "xs",
            color: subTitleColor || Global/* theme.greyText7 */.rS.greyText7,
            "data-test-id": "OrderDetailV2PolicyDownload-SpanTag",
            children: subTitle
          }) : null, desc ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "xs",
            color: descColor || Global/* theme.greyText7 */.rS.greyText7,
            "data-test-id": "OrderDetailV2PolicyDownload-SpanTag",
            children: desc
          }) : null]
        }), showSpinner ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* Spinner */.$j, {
          "data-test-id": "OrderDetailV2PolicyDownload-Spinner"
        }) : statusIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(StatusIcon, {
          src: statusIcon,
          alt: "",
          "data-test-id": "OrderDetailV2PolicyDownload-StatusIcon"
        }) : null]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PolicyDownload/index.ts


/***/ }),

/***/ 54412:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* reexport */ OrderDetailV2PriceBreakup)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PriceBreakup/OrderDetailV2PriceBreakup.style.ts

const PriceBreakupTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__PriceBreakupTitle",
  componentId: "cksztp-0"
})(["margin-bottom:16px;"]);
const PriceBreakupContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__PriceBreakupContainer",
  componentId: "cksztp-1"
})(["display:flex;flex-direction:column;gap:25px;"]);
const BreakupSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__BreakupSection",
  componentId: "cksztp-2"
})(["display:flex;flex-direction:column;gap:4px;"]);
const ExtraChargesSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__ExtraChargesSection",
  componentId: "cksztp-3"
})(["display:flex;flex-direction:column;gap:4px;"]);
const FinalAmountSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__FinalAmountSection",
  componentId: "cksztp-4"
})(["display:flex;flex-direction:column;gap:4px;"]);
const BreakupItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2PriceBreakupstyle__BreakupItem",
  componentId: "cksztp-5"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;font-family:Lato,sans-serif;line-height:100%;letter-spacing:0;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PriceBreakup/OrderDetailV2PriceBreakup.tsx






const OrderDetailV2PriceBreakup = ({
  title,
  breakupList,
  extraCharges,
  finalAmount
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* Card */.Zb, {
    "data-test-id": "OrderDetailV2PriceBreakup-Card",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* CardPadding */.fW, {
      "data-test-id": "OrderDetailV2PriceBreakup-CardPadding",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PriceBreakupTitle, {
        "data-test-id": "OrderDetailV2PriceBreakup-PriceBreakupTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontWeight: "bold",
          fontSize: "md",
          "data-test-id": "OrderDetailV2PriceBreakup-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: title,
            "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceBreakupContainer, {
        "data-test-id": "OrderDetailV2PriceBreakup-PriceBreakupContainer",
        children: [breakupList.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreakupSection, {
          "data-test-id": "OrderDetailV2PriceBreakup-BreakupSection",
          children: breakupList.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(BreakupItem, {
            "data-test-id": "OrderDetailV2PriceBreakup-BreakupItem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.label,
              baseStyle: {
                fontWeight: item.style?.fontWeight || "400",
                fontSize: item.style?.fontSize ? `${item.style.fontSize}px` : "12px",
                color: item.style?.color || Global/* theme.blackText */.rS.blackText,
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.value,
              baseStyle: {
                fontWeight: item.style?.fontWeight || "400",
                fontSize: item.style?.fontSize ? `${item.style.fontSize}px` : "12px",
                textAlign: "right",
                flexShrink: 0,
                marginLeft: "auto"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            })]
          }, `breakup-${index}`))
        }), extraCharges.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ExtraChargesSection, {
          "data-test-id": "OrderDetailV2PriceBreakup-ExtraChargesSection",
          children: extraCharges.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(BreakupItem, {
            "data-test-id": "OrderDetailV2PriceBreakup-BreakupItem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.label,
              baseStyle: {
                fontWeight: item.style?.fontWeight || "400",
                fontSize: item.style?.fontSize ? `${item.style.fontSize}px` : "14px",
                color: item.style?.color || Global/* theme.blackText */.rS.blackText,
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.value,
              baseStyle: {
                fontWeight: item.style?.fontWeight || "400",
                fontSize: item.style?.fontSize ? `${item.style.fontSize}px` : "14px",
                textAlign: "right",
                flexShrink: 0,
                marginLeft: "auto"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            })]
          }, `extra-${index}`))
        }), finalAmount && /*#__PURE__*/(0,jsx_runtime.jsx)(FinalAmountSection, {
          "data-test-id": "OrderDetailV2PriceBreakup-FinalAmountSection",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(BreakupItem, {
            "data-test-id": "OrderDetailV2PriceBreakup-BreakupItem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: finalAmount.label,
              baseStyle: {
                fontWeight: finalAmount.style?.fontWeight || "400",
                fontSize: finalAmount.style?.fontSize ? `${finalAmount.style.fontSize}px` : "16px",
                color: finalAmount.style?.color || Global/* theme.blackText */.rS.blackText,
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: finalAmount.value,
              baseStyle: {
                fontWeight: finalAmount.style?.fontWeight || "400",
                fontSize: finalAmount.style?.fontSize ? `${finalAmount.style.fontSize}px` : "16px",
                textAlign: "right",
                flexShrink: 0,
                marginLeft: "auto"
              },
              "data-test-id": "OrderDetailV2PriceBreakup-FormattedText"
            })]
          })
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2PriceBreakup/index.ts


/***/ }),

/***/ 89159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": () => (/* reexport */ OrderDetailV2Tooltip)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Tooltip/OrderDetailV2Tooltip.tsx








const TooltipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2Tooltip__TooltipContainer",
  componentId: "sc-1ocokaj-0"
})(["position:relative;display:inline-block;@media ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
const TooltipContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailV2Tooltip__TooltipContent",
  componentId: "sc-1ocokaj-1"
})(["position:fixed;background-color:", ";color:", ";padding:8px 12px;border-radius:4px;font-size:14px;line-height:20px;white-space:", ";width:", ";z-index:10000;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);pointer-events:none;opacity:0;visibility:hidden;transition:opacity 0.2s ease-in-out,visibility 0.2s ease-in-out;word-wrap:break-word;overflow-wrap:break-word;top:", ";left:", ";transform:", ";&::after{content:\"\";position:absolute;width:0;height:0;", "}&.visible{opacity:1;visibility:visible;}"], Global/* theme.persianGreen */.rS.persianGreen, Global/* theme.whiteText */.rS.whiteText, props => props.width ? "normal" : "nowrap", props => props.width || "170px", props => props.top !== undefined ? `${props.top}px` : "auto", props => props.left !== undefined ? `${props.left}px` : "auto", props => {
  switch (props.position) {
    case "top":
    case "bottom":
      return "translateX(-50%)";

    case "left":
    case "right":
      return "translateY(-50%)";

    default:
      return "translateX(-50%)";
  }
}, props => {
  switch (props.position) {
    case "top":
      return `
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid ${Global/* theme.persianGreen */.rS.persianGreen};
          `;

    case "bottom":
      return `
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid ${Global/* theme.persianGreen */.rS.persianGreen};
          `;

    case "left":
      return `
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 6px solid ${Global/* theme.persianGreen */.rS.persianGreen};
          `;

    case "right":
      return `
            right: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-right: 6px solid ${Global/* theme.persianGreen */.rS.persianGreen};
          `;

    default:
      return `
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid ${Global/* theme.persianGreen */.rS.persianGreen};
          `;
  }
});
const OrderDetailV2Tooltip = ({
  message,
  children,
  trigger = "hover",
  show = false,
  position = "top",
  autoHideDelay = 0,
  disabled = false,
  width
}) => {
  const {
    0: isVisible,
    1: setIsVisible
  } = (0,react.useState)(false);
  const {
    0: tooltipPosition,
    1: setTooltipPosition
  } = (0,react.useState)(null);
  const timeoutRef = (0,react.useRef)(null);
  const autoHideTimeoutRef = (0,react.useRef)(null);
  const triggerRef = (0,react.useRef)(null);
  const prevShowRef = (0,react.useRef)(show);
  const hasMountedRef = (0,react.useRef)(false);
  const calculatePosition = (0,react.useCallback)(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const tooltipOffset = 8; // 8px gap between trigger and tooltip

    const arrowSize = 6; // Arrow size

    let top = 0;
    let left = 0;

    switch (position) {
      case "top":
        top = rect.top - tooltipOffset - arrowSize;
        left = rect.left + rect.width / 2;
        break;

      case "bottom":
        top = rect.bottom + tooltipOffset + arrowSize;
        left = rect.left + rect.width / 2;
        break;

      case "left":
        top = rect.top + rect.height / 2;
        left = rect.left - tooltipOffset - arrowSize;
        break;

      case "right":
        top = rect.top + rect.height / 2;
        left = rect.right + tooltipOffset + arrowSize;
        break;

      default:
        top = rect.top - tooltipOffset - arrowSize;
        left = rect.left + rect.width / 2;
    }

    setTooltipPosition({
      top,
      left
    });
  }, [position]);
  (0,react.useEffect)(() => {
    // Mark as mounted after first render
    hasMountedRef.current = true;
  }, []);
  (0,react.useEffect)(() => {
    // Handle state-based visibility
    if (trigger === "state") {
      // For "state" trigger, always respond to show prop
      if (show && !disabled && message) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } else if (trigger === "both") {
      // For "both" trigger, only respond to show prop changes (not initial mount)
      // This prevents tooltips from showing on page load
      const showChanged = prevShowRef.current !== show;

      if (showChanged && hasMountedRef.current) {
        if (show && !disabled && message) {
          setIsVisible(true);
        } else if (!show) {// Only hide if show becomes false, don't override hover state
          // The hover handlers will manage visibility when user hovers
        }
      }

      prevShowRef.current = show;
    }
  }, [show, trigger, disabled, message]);
  (0,react.useEffect)(() => {
    if (!isVisible) {
      setTooltipPosition(null);
      return;
    } // Use requestAnimationFrame to ensure DOM is ready


    requestAnimationFrame(() => {
      calculatePosition();
    });

    const handleScroll = () => calculatePosition();

    const handleResize = () => calculatePosition();

    window.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", handleResize);
    };
  }, [isVisible, calculatePosition]);
  (0,react.useEffect)(() => {
    // Handle auto-hide
    if (isVisible && autoHideDelay > 0) {
      autoHideTimeoutRef.current = setTimeout(() => {
        setIsVisible(false);
      }, autoHideDelay);
    }

    return () => {
      if (autoHideTimeoutRef.current) {
        clearTimeout(autoHideTimeoutRef.current);
      }
    };
  }, [isVisible, autoHideDelay]);

  const handleMouseEnter = () => {
    if (disabled) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (trigger === "hover" || trigger === "both") {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (trigger === "hover" || trigger === "both") {
      // Always hide on mouse leave for hover-based triggers
      // For "both" trigger, hover takes precedence over state
      setIsVisible(false);
    }
  };

  if (!message || disabled) {
    return children;
  }

  const tooltipContent = isVisible && tooltipPosition ? /*#__PURE__*/(0,jsx_runtime.jsx)(TooltipContent, {
    position: position,
    width: width || "170px",
    top: tooltipPosition.top,
    left: tooltipPosition.left,
    className: isVisible ? "visible" : "",
    "data-test-id": "OrderDetailV2Tooltip-tooltipContent-TooltipContent",
    children: message
  }) : null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TooltipContainer, {
      ref: triggerRef,
      isVisible: isVisible,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      "data-test-id": "OrderDetailV2Tooltip-TooltipContainer",
      children: children
    }), tooltipContent && /*#__PURE__*/(0,react_dom.createPortal)(tooltipContent, document.body)]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Tooltip/index.ts


/***/ }),

/***/ 39922:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* reexport */ OrderDetailV2Travellers)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2.style.ts
var OrderDetailV2_style = __webpack_require__(16186);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/OrderDetailV2Context.tsx
var OrderDetailV2Context = __webpack_require__(23027);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/EditTravellersModal/index.ts + 1 modules
var EditTravellersModal = __webpack_require__(40648);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Tooltip/index.ts + 1 modules
var OrderDetailV2Tooltip = __webpack_require__(89159);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/index.ts + 2 modules
var TextButton = __webpack_require__(60313);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Travellers/OrderDetailV2Travellers.tsx












const OrderDetailV2Travellers = ({
  icon,
  title,
  actionLabel,
  isActionDisabled,
  actionDisabledReason,
  persuasionText,
  travellers,
  formConfig,
  modalConfig,
  entities = [],
  actionList = [],
  isActionVisible = true
}) => {
  const ctx = (0,OrderDetailV2Context/* useOrderDetailV2 */.g)();
  const {
    bookingId,
    refreshOrderDetails
  } = ctx;
  const disabled = Boolean(isActionDisabled);
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = (0,react.useState)(false);
  const device = (0,src/* useBreakpointV2 */.bU)();

  const openTravellersModal = () => {
    if (!disabled && formConfig) {
      setIsModalOpen(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* Card */.Zb, {
    "data-test-id": "OrderDetailV2Travellers-Card",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailV2_style/* CardPadding */.fW, {
      "data-test-id": "OrderDetailV2Travellers-CardPadding",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 0 10px",
        "data-test-id": "OrderDetailV2Travellers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignItems: "center",
          gap: "8px",
          margin: "0",
          "data-test-id": "OrderDetailV2Travellers-FlexComp",
          children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* SectionHeaderIcon */.vN, {
            "data-test-id": "OrderDetailV2Travellers-SectionHeaderIcon",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              src: icon,
              width: "20px",
              height: "20px",
              "data-test-id": "OrderDetailV2Travellers-ImageComponent"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "large",
            fontWeight: "bold",
            color: device === "lg" ? Global/* theme.greyText */.rS.greyText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "OrderDetailV2Travellers-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: {
                text: {
                  value: title,
                  styles: {
                    mobile: {
                      "font-size": "16px" // Mobile font size

                    }
                  }
                }
              },
              "data-test-id": "OrderDetailV2Travellers-FormattedText"
            })
          })]
        }), device === "lg" && isActionVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2Tooltip/* OrderDetailV2Tooltip */.K, {
          message: actionDisabledReason || "",
          trigger: "both",
          show: disabled,
          position: "bottom",
          autoHideDelay: 5000,
          disabled: !disabled || !actionDisabledReason,
          "data-test-id": "OrderDetailV2Travellers-OrderDetailV2Tooltip",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
            btnTxt: actionLabel,
            onClick: openTravellersModal,
            showDefaultRightIcon: false,
            disabled: disabled,
            "data-test-id": "OrderDetailV2Travellers-TextButton"
          })
        })]
      }), persuasionText && device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* InfoStrip */.gp, {
        "data-test-id": "OrderDetailV2Travellers-InfoStrip",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "OrderDetailV2Travellers-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: persuasionText,
            "data-test-id": "OrderDetailV2Travellers-FormattedText"
          })
        })
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ListBox */.wb, {
        "data-test-id": "OrderDetailV2Travellers-ListBox",
        children: travellers.map((t, index) => {
          const {
            policyUrl,
            cta,
            title,
            desc
          } = t;
          const {
            label,
            icon,
            actionId,
            isEnabled,
            isVisible
          } = cta || {};

          const handleCtaClick = () => {
            if (policyUrl && isEnabled) {
              window.open(policyUrl, "_blank");
            }
          };

          return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* ListRow */.wc, {
            "data-test-id": "OrderDetailV2Travellers-ListRow",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              alignItems: "flex-start",
              justifyContent: "space-between",
              margin: "0",
              "data-test-id": "OrderDetailV2Travellers-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  minWidth: 0
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: "md",
                  fontWeight: "bold",
                  "data-test-id": "OrderDetailV2Travellers-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                    value: {
                      text: {
                        value: title,
                        styles: {
                          mobile: {
                            "font-size": "14px"
                          }
                        }
                      }
                    },
                    "data-test-id": "OrderDetailV2Travellers-FormattedText"
                  })
                }), desc && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* RowMeta */.ri, {
                  "data-test-id": "OrderDetailV2Travellers-RowMeta",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                    fontSize: "sm",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "OrderDetailV2Travellers-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                      value: {
                        text: {
                          value: desc,
                          styles: {
                            mobile: {
                              "font-size": "12px" // Mobile font size

                            }
                          }
                        }
                      },
                      "data-test-id": "OrderDetailV2Travellers-FormattedText"
                    })
                  })
                })]
              }), isVisible && policyUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
                btnTxt: label,
                leftIcon: icon,
                disabled: !isEnabled,
                onClick: handleCtaClick,
                showDefaultRightIcon: false,
                "data-test-id": "OrderDetailV2Travellers-TextButton"
              })]
            })
          }, `${t?.id || "traveller"}-${index}`);
        })
      })]
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaDivider */.Bs, {
        "data-test-id": "OrderDetailV2Travellers-CardCtaDivider"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2_style/* CardCtaButtonList */.ci, {
        "data-test-id": "OrderDetailV2Travellers-CardCtaButtonList",
        children: actionList.map(action => /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailV2Tooltip/* OrderDetailV2Tooltip */.K, {
          message: actionDisabledReason || "",
          trigger: "both",
          show: disabled,
          position: "bottom",
          autoHideDelay: 5000,
          disabled: !disabled || !actionDisabledReason,
          "data-test-id": "OrderDetailV2Travellers-OrderDetailV2Tooltip",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
            fullWidth: true,
            btnTxt: action.text,
            disabled: disabled,
            onClick: openTravellersModal,
            "data-test-id": "OrderDetailV2Travellers-TextButton"
          })
        }, action.id))
      })]
    }), formConfig && bookingId && /*#__PURE__*/(0,jsx_runtime.jsx)(EditTravellersModal/* EditTravellersModal */.rj, {
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false),
      formConfig: formConfig,
      entities: entities,
      bookingId: bookingId,
      onSave: () => {},
      onEndorsementSuccess: refreshOrderDetails,
      modalTitle: modalConfig?.header?.title || "Edit Travellers",
      saveButtonLabel: modalConfig?.footer?.cta?.[0]?.label || "SAVE DETAILS",
      "data-test-id": "OrderDetailV2Travellers-EditTravellersModal"
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/OrderDetailV2Travellers/index.ts


/***/ }),

/***/ 60313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": () => (/* reexport */ TextButton_TextButton)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/TextButton.style.ts



const TextButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TextButtonstyle__TextButtonContainer",
  componentId: "sc-4y80y9-0"
})(["background:", ";border:none;padding:0;display:flex;gap:2px;width:", ";cursor:pointer;outline:none;position:relative;transition:opacity 0.2s ease;opacity:", ";font-family:inherit;font-size:inherit;line-height:inherit;text-align:left;-webkit-appearance:none;-moz-appearance:none;appearance:none;box-shadow:none;img,svg{width:100%;height:100%;display:block;", "}&:hover:not(:disabled){opacity:0.8;}&:focus-visible{outline:2px solid ", ";outline-offset:2px;}&:disabled{pointer-events:auto;cursor:not-allowed;}@media ", "{padding:16px 12px;}"], Global/* theme.whiteText */.rS.whiteText, props => props.fullWidth ? "100%" : "auto", props => props.disabled ? 0.45 : 1, props => props.disabled && `
      filter: grayscale(100%);
      opacity: 0.90;
    `, Global/* theme.blueText */.rS.blueText, src.deviceType.mobile);
const TextButtonContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextButtonstyle__TextButtonContent",
  componentId: "sc-4y80y9-1"
})(["display:flex;align-items:center;gap:2px;flex:1;min-width:0;width:100%;span{flex:1 0 0;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;}"]);
const LeftIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextButtonstyle__LeftIconWrapper",
  componentId: "sc-4y80y9-2"
})(["margin-right:8px;display:flex;align-items:center;"]);
const RightIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextButtonstyle__RightIconWrapper",
  componentId: "sc-4y80y9-3"
})(["margin-left:auto;display:flex;align-items:center;"]);
const TextButtonIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextButtonstyle__TextButtonIcon",
  componentId: "sc-4y80y9-4"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;img,svg{width:100%;height:100%;display:block;", "}"], props => props.disabled && `
      filter: grayscale(100%);
      opacity: 0.90;
    `);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/TextButton.tsx




/**
 * TextButton - Atomic level reusable text button component
 *
 * A text-based button component with optional left and right icons.
 * Designed for use cases like "View all benefits" with arrow indicators.
 * If no right icon is provided, defaults to blueChev icon.
 *
 * For tooltip functionality, wrap this component with OrderDetailV2Tooltip.
 *
 * @example
 * ```tsx
 * // With default icon (blueChev)
 * <TextButton
 *   btnTxt="View all 15 benefits"
 *   onClick={() => handleViewBenefits()}
 * />
 * ```
 *
 * @example
 * ```tsx
 * // With tooltip (composed separately)
 * <OrderDetailV2Tooltip
 *   message="Please wait till policy document is generated"
 *   trigger="hover"
 *   position="bottom"
 * >
 *   <TextButton
 *     btnTxt="Edit Details"
 *     disabled
 *     onClick={() => handleEdit()}
 *   />
 * </OrderDetailV2Tooltip>
 * ```
 *
 * @example
 * ```tsx
 * // With left and right icons
 * <TextButton
 *   btnTxt="View Details"
 *   leftIcon="/path/to/left-icon.svg"
 *   rightIcon="/path/to/right-icon.svg"
 *   onClick={() => handleClick()}
 * />
 * ```
 */




const LeftIcon = ({
  iconSrc,
  disabled
}) => {
  if (!iconSrc) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextButtonIcon, {
    disabled: disabled,
    "data-test-id": "LeftIcon-TextButtonIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      src: iconSrc,
      width: "16px",
      height: "16px",
      "data-test-id": "LeftIcon-ImageComponent"
    })
  });
};

const RightIcon = ({
  rightIcon,
  showDefaultRightIcon = true,
  disabled
}) => {
  // If showDefaultRightIcon is false and rightIcon is provided, use rightIcon
  if (!showDefaultRightIcon && rightIcon) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TextButtonIcon, {
      disabled: disabled,
      "data-test-id": "RightIcon-TextButtonIcon",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: rightIcon,
        width: "12px",
        height: "12px",
        "data-test-id": "RightIcon-ImageComponent"
      })
    });
  } // If showDefaultRightIcon is false and no rightIcon, show nothing


  if (!showDefaultRightIcon && !rightIcon) {
    return null;
  } // Default: show blueChev icon (or rightIcon if provided and showDefaultRightIcon is true)


  const iconSrc = rightIcon || "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg";
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextButtonIcon, {
    disabled: disabled,
    "data-test-id": "RightIcon-TextButtonIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      src: iconSrc,
      width: "12px",
      height: "12px",
      "data-test-id": "RightIcon-ImageComponent"
    })
  });
};

const ButtonText = ({
  btnTxt,
  disabled
}) => {
  if (!btnTxt) {
    return null;
  }

  if (typeof btnTxt === "string") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "sm",
      fontWeight: "bold",
      color: disabled ? Global/* theme.greyText */.rS.greyText : Global/* theme.blueText */.rS.blueText,
      "data-test-id": "ButtonText-SpanTag",
      children: btnTxt
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
    fontSize: "sm",
    fontWeight: "bold",
    color: disabled ? Global/* theme.greyText */.rS.greyText : Global/* theme.blueText */.rS.blueText,
    "data-test-id": "ButtonText-SpanTag",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
      value: btnTxt,
      "data-test-id": "ButtonText-FormattedText"
    })
  });
};

const TextButton = ({
  btnTxt,
  leftIcon,
  rightIcon,
  showDefaultRightIcon = true,
  onClick,
  fullWidth = false,
  hasBorder = true,
  disabled = false,
  className,
  type = "button"
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextButtonContainer, {
    onClick: handleClick,
    fullWidth: fullWidth,
    hasBorder: hasBorder,
    disabled: disabled,
    className: className,
    type: type,
    "aria-disabled": disabled,
    "aria-label": typeof btnTxt === "string" ? btnTxt : undefined,
    "data-test-id": "TextButton-TextButtonContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextButtonContent, {
      "data-test-id": "TextButton-TextButtonContent",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LeftIconWrapper, {
        "data-test-id": "TextButton-LeftIconWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LeftIcon, {
          iconSrc: leftIcon,
          disabled: disabled,
          "data-test-id": "TextButton-LeftIcon"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonText, {
        btnTxt: btnTxt,
        disabled: disabled,
        "data-test-id": "TextButton-ButtonText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RightIconWrapper, {
        "data-test-id": "TextButton-RightIconWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RightIcon, {
          rightIcon: rightIcon,
          showDefaultRightIcon: showDefaultRightIcon,
          disabled: disabled,
          "data-test-id": "TextButton-RightIcon"
        })
      })]
    })
  });
};

/* harmony default export */ const TextButton_TextButton = (TextButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/components/TextButton/index.ts


/***/ }),

/***/ 23087:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XK": () => (/* reexport */ ORDER_DETAIL_V2_ASSETS),
  "Mr": () => (/* reexport */ ORDER_DETAIL_V2_URLS)
});

// UNUSED EXPORTS: ORDER_STATUS

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/orderDetailV2.constants.ts
const ORDER_DETAIL_V2_ASSETS = {
  TRIP_SECURED_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/trip_Secured_9a14d8e25c.svg",
  PLAN_COVERAGE_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/P_and_C_Icon_3x_59fc3a881e.png",
  PRIMARY_CONTACT_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/Primary_Contact_Icon_3x_9a81d8e8f4.png",
  MAIL_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/mail_Icon_cf3395e217.svg",
  CALL_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/call_Icon_94b21de941.svg",
  VALIDATION_ERROR_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/Leading_Icon_Swap_62bf92f616.svg",
  SUCCESS_ICON: "https://tripmoneycmsimgak.mmtcdn.com/img/No_Trailing_Icon_a5c58b394f.svg"
};
const ORDER_DETAIL_V2_URLS = {
  MY_TRIPS: "https://supportz.makemytrip.com/Mima/BookingSummary/"
};
const ORDER_STATUS = {
  UPCOMING: "UPCOMING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetailV2/constants/index.ts


/***/ })

}]);